// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/company-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/sos-header-right-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/notification_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/Edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/Delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../img/sos-header-right-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../img/globe.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/Upload.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/Upload1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/eye.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../img//fields/telephone.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indi-app {}

/* Begin :  custom style for native browser scroll bar*/

body.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar,
.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

body.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar {
  background: rgba(255, 255, 255, 1);
}

.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar:hover {
  background: rgba(255, 255, 255, 0);
}

.indi-app:not(.indi-app-on-macintosh) *:hover::-webkit-scrollbar-track {
  background-color: transparent;
}

body.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb,
.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 6px solid transparent;
  min-height: 50px;
  background-color: transparent;
}

body.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);
}

body.indi-app:not(.indi-app-on-macintosh):hover::-webkit-scrollbar-thumb,
.indi-app:not(.indi-app-on-macintosh) *:hover::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);
}

.indi-app:not(.indi-app-on-macintosh) .indi-app-dark-area:hover::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 16px 16px 0px rgba(255, 255, 255, 0.75);
}

body.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb:hover,
.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar-thumb:hover {
  border: 4px solid transparent;
  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);
  background-color: transparent;
}

.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area:hover::-webkit-scrollbar-thumb,
.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area::-webkit-scrollbar-thumb:hover {
  -webkit-box-shadow: inset 16px 16px 0px #eeeeee;
}

.indi-app .indi-app-normal-scrolling {
  overflow-x: auto;
  overflow-y: auto;
  overflow: auto !important;
  overflow: overlay !important;
}

.indi-app:not(.indi-app-on-macintosh) .indi-app-normal-scrolling {
  scrollbar-width: thin;
  scrollbar-color: rgb(128 130 133) transparent;
}

.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area:hover {
  scrollbar-color: #eeeeee transparent;
}

.indi-app .indi-app-normal-scrolling {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/*TODO: Will be moved to hisos side - End*/

/* End :  custom style for native browser scroll bar*/

.indi-app .indi-company-logo {
  background: #1fc;
}

.indi-app .indi-header .indi-company-logo {
  background: #ffc;
}

.indi-app .indi-footer .indi-company-logo {
  background: #ffc;
}

.indi-app .indi-global-mask {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 99998;
}

.indi-app .indi-global-mask .indi-global-mask-loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-weight: 700;
  height: 100%;
  width: 100%;
}

.indi-app .indi-global-mask .indi-global-mask-loading-text .indi-global-mask-loading-text-message {
  margin-left: 9px;
}

.indi-app .indi-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* TEMP changes */
/* .indi-app .indi-header-wrapper {
  background-color: lightseagreen;
  display: flex;
}
 */

/*Header start*/
.indi-app .indi-header-wrapper {
  height: 100px;
}

.indi-app .indi-header-left-logo-wrapper,
.indi-app .indi-header-right-bg-wrapper>div {
  display: flex;
  align-items: center;
}

.indi-app .btn.indi-header-userprofile-btn:first-child:active {
  background-color: #fff;
  border-radius: 50%;
}

.indi-app .indi-logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  height: 80px;
  width: 140px;
  background-size: contain;
}

.indi-app .indi-header-right-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  height: 100px;
  width: 69px;
  margin-right: 41px;
  background-size: contain;
}

.indi-app .indi-header-wrapper .btn {
  padding: 0;
}

.indi-app .indi-notification-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  width: 19px;
  height: 22.5px;
  background-size: contain;
  margin: 0.5rem 1rem;

}

.indi-app .indi-header-profile-image {
  height: 26px;
  width: 26px;
  cursor: pointer;
  border-radius: 50%;
}

.indi-header-user-profile-firstname {
  margin: 0 6px;
  font-size: 12px;
  font-weight: 700;
}

.indi-app .container {
  max-width: 100%;
}

/*Header end*/


/*Body start*/

.indi-app .indi-body-wrapper {
  background-color: lightskyblue;
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #2f4594;
}

.indi-app .indi-full-height {
  background: #fff;
  flex: 1 1 auto;
  padding: 0 12px;
  height: 100%;
}

.indi-app .indi-badge-add-button-wrapper {
  background-color: #1fc;
}

.indi-app .indi-badge-list-wrapper {
  background-color: rgb(15, 130, 159);
}

.indi-app .indi-tile {
  flex: 1 1 auto;
  background: green;
  height: calc(100% - 80px);
  width: 25%;
  padding: 16px;
  margin: 16px;
  margin-bottom: 64px;
}

.indi-app .indi-navmenu-item {
  display: flex;
  /* padding: 8px; */
  /* border: 1px solid gray; */
}

.indi-app .indi-navmenu-item .indi-navmenu-active,
.indi-app .indi-navmenu-item .indi-navmenu-inactive {
  background: transparent;
  padding: 8px;
  width: 100%;
  height: 100%;
  text-decoration: none;
  display: flex;
  height: 56px;
  align-items: center;
}

.indi-app .indi-navmenu-item .indi-navmenu-inactive:hover {
  background: #23286236;
}

.indi-app .indi-navmenu-item .indi-navmenu-active {
  background: #304697;
  /* background: #3a52a7; */
  color: #fff;
  font-weight: bold;
}

.indi-app .indi-left-navigation-wrapper {
  padding-top: 20px;
  border-radius: 6px;
  height: 100%;
}

.indi-app .indi-left-navigation-wrapper,
.indi-app .indi-content-area-wrapper {
  background: #f0f3f9;
  overflow-y: auto;
  overflow-y: overlay;
}

.indi-app .indi-content-area-wrapper {
  border-radius: 6px;
  padding: 20px;
}

.indi-app .indi-content-area-wrapper .indi-add-card-wrapper {
  width: 100%;
  height: 100%;
}

.indi-app .indi-content-area-wrapper .indi-add-card-wrapper .indi-card-item-parent.card-with-bg {
  max-width: 300px;
  min-width: 240px;
  margin: 0 auto;
}

.indi-app .indi-content-area-wrapper button.btn.btn-primary,
.indi-app .modal-dialog button.btn.btn-primary {
  /* float: right; */
  margin: 12px 0 12px 8px;
  background-color: #232862;
  border: 1px solid #232862;
}

.indi-app .indi-content-area-wrapper form {
  height: 100%;
  width: 100%;
}

.indi-app img.indi-w-32 {
  width: 32px;
  margin: 4px 16px;
  color: #010fb8;
}

.indi-app .indi-content-area-wrapper img.indi-w-20 {
  margin: 8px;
  color: #010fb8;
}

.indi-app a.indi-navmenu-inactive span {
  color: #010fb8;
}

.indi-app .indi-navmenu-active img.indi-w-32 {}

.indi-app .indi-qrcode-box-img-col {
  position: relative;
}

.indi-app .indi-qrcode-box-img-col img {
  background-color: #2f45947a;
  width: 40px;
  height: 29px;
}

.indi-app .indi-qrcode-box-img-col img.indi-qrcode-qrcode {
  width: 100px;
  height: 100px;
}

/*utility classes*/
.indi-place-me-top-right {
  position: absolute;
  top: 16px;
  right: 16px;
}

.indi-place-me-top-left {
  position: absolute;
  bottom: 16px;
  left: 16px;
}

.indi-place-me-bottom-right {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

.indi-qrcode-box-codes {
  position: absolute;
  bottom: 2px;
  right: -12px;
}

div[dir="rtl"] .indi-qrcode-box-codes {
  right: unset;
  left: -12px;
}

.indi-wrap-overflow-icons {
  max-width: calc(100% - 90px);
  border-bottom: 10px solid #fff;
}

.indi-place-me-bottom-left {
  position: absolute;
  bottom: 16px;
  left: 16px;
}

/*Body end*/

/*popover style start*/
.indi-app .popover-body {
  color: #2f4694;
}

/*popover style end*/

/*footer start*/
.indi-app .indi-add-card-item-footer {
  box-shadow: 0px 0px 4px 0px #46516f;
  margin-top: 10px;
}

.indi-app .indi-footer-wrapper {
  background-color: #ffffff;
  font-weight: bold;
  height: 80px;
  color: #2f4694;
}

.indi-app .indi-footer-wrapper .indi-logo {
  height: 48px;
  width: 84px;
}

.indi-app .indi-footer-wrapper .indi-footer-logo-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 6px;
}


.indi-app .indi-footer-wrapper .indi-footer-logo,
.indi-app .indi-footer-wrapper .indi-footer-logo-text {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0;
  margin: 0 24px;
}

.indi-app .indi-footer-wrapper .navbar-nav {
  margin: 0 0 0 24px;
}

.indi-app .indi-footer-wrapper .navbar-nav-left .nav-link {
  margin: 0 4px;
  color: #2f4694;
  font-size: 12px;
}

.indi-app .indi-footer-wrapper .indi-copy-text {
  font-weight: bold;
  font-size: 11px;
  line-height: 15px;
  margin: 0 48px;
  padding-bottom: 5px;
}

.indi-app .indi-w-20 {
  width: 16px;
  height: 16px;
  margin: 0px;
}

/*Footer end*/


.indi-app .indi-body2-wrapper {
  padding: 20px;
}

.indi-app .indi-body-cards-wrapper {
  flex-flow: column;
}

.indi-app .indi-body-action-bar,
.indi-app .indi-add-card-title {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.indi-app .indi-body-title,
.indi-app .indi-body-action-bar,
.indi-app .indi-add-card-title,
.indi-app .indi-user-settings-page-header,
.indi-app .indi-signature-title {
  font-weight: bold;
  color: #2f4694;
  line-height: 40px;
  padding: 0 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.indi-app .indi-signature-title {
  border-top: 10px solid #fff;
  border-radius: 10px;
}

.indi-app .indi-signature-item-wrapper .indi-logo-image {
  padding: 0;
  border: 4px solid #232862;
  border-radius: 6px 0 0 6px;
  margin-top: 6px;
  margin-right: -14px;
  background-color: #232862;
}

.indi-app .indi-signature-item-wrapper .indi-logo-image {
  padding: 0;
  border: 4px solid #232862;
  border-radius: 6px 0 0 6px;
  margin-top: 6px;
  margin-right: -14px;
  background-color: #232862;
}

.indi-app .indi-signature-item-wrapper .indi-joint-logo-image {
  border-radius: 0;
}

.indi-app .indi-qrcode-logo-images-wrapper {
  right: 0;
  position: absolute;
  width: 16.5%;
}

.indi-app .indi-logo-img-wrapper-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 14px;
  width: 30.5%;
}

.indi-app .indi-qrcode-logo-images-wrapper .indi-logo-image {
  flex: 1 1;
}

.indi-app div[dir="rtl"].indi-signature-item-wrapper .indi-qrcode-logo-images-wrapper {
  right: unset;
  left: 0;
}
.indi-app div[dir="rtl"].indi-signature-item-wrapper .indi-logo-image {
  border-radius: 0 6px 6px 0;
  margin-right: 0;
  margin-left: -14px;
}

.indi-app .indi-signature-item-wrapper .indi-logo-image img {
  width: 100%;
  background-color: #232862;
}

.indi-app .indi-body-actions {
  display: flex;
  flex-flow: row;
  justify-content: end;
}

.indi-app .indi-body-action {
  margin-left: 10px;
  cursor: pointer;
  white-space: nowrap;
}

.indi-app .indi-add-card-wrapper,
.indi-app .indi-content-area-wrapper,
.indi-app .indi-cards-collection-wrapper {
  height: calc(100% - 32px);
  padding: 0;
  overflow-x: auto;
  overflow-x: overlay;
}

.indi-app .indi-placeholder-add-card.indi-card-item-wrapper {
  border: 2px dashed #2d326c;
  border-radius: 10px;
  flex-flow: column;
  padding: 10px;
}

.indi-app .indi-card-item-wrapper {
  width: 300px;
  min-width: 300px;
  cursor: pointer;
  margin: 16px;
  position: relative;
}

.indi-app .indi-card-item-parent {
  width: 100%;
  height: 100%;
  color: #fff;
  background-size: cover;
}

.indi-app .indi-card-item-parent.card-with-bg {
  /* background-image: url("../img/Card.png"); */
  padding: 16px;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  position: relative;
}

.indi-app .indi-card-template-item-wrapper {
  background-color: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  /* z-index: -1; */
}

.indi-app .indi-card-template-item-wrapper:hover {
  opacity: 1;
}

.indi-app .indi-card-template-item-wrapper .indi-item-edit-overlay,
.indi-app .indi-card-template-item-wrapper .indi-item-delete-overlay {
  background-repeat: no-repeat;
  background-size: contain;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  display: flex;
}

.indi-app .indi-card-template-item-wrapper .indi-item-edit-overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  top: calc(50% - 150px);
}

.indi-app .indi-card-template-item-wrapper .indi-item-delete-overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  top: calc(50% - 100px);
}

.indi-app .indi-card-upload-picture {
  min-width: 100px;
  min-height: 100px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: 52px;
  margin-bottom: 10px;
  max-width: 100px;
  max-height: 100px;
  overflow: hidden;
}

.indi-app .indi-card-fields {
  overflow-y: auto;
  overflow-y: overlay;
  width: inherit;
  margin-bottom: 36px;
}

.indi-app .indi-card-name {
  text-align: center;
}

.indi-app .indi-card-name.indi-mini-card-name {
  text-align: left;
}

.indi-app .indi-template-title,
.indi-app .indi-card-title {
  padding-bottom: 0px;
  line-height: 19px;
  min-height: 20px;
  max-height: 40px;
  text-align: center;
  font-size: 14px;
}

.indi-app .indi-card-title.indi-mini-card-title {
  font-size: 10px;
  text-align: left;
}

.indi-app div[dir="rtl"] .indi-card-title.indi-mini-card-title {
  text-align: right;
}

.indi-app .indi-template-title {
  font-weight: bold;
}

.indi-app .indi-card-field-wrapper>div {
  padding-bottom: 16px;
}

.indi-app .indi-placeholder-add-card-img {
  height: 100%;
  justify-content: center;
  align-items: center;
}

.indi-app .indi-placeholder-add-card:hover {
  background-color: #dbe2fa;
}

.indi-app .indi-placeholder-add-card-img img {
  height: 72px;
  width: 72px;
}

.indi-app .indi-placeholder-add-card-text {
  justify-content: center;
  align-items: center;
  color: #2f4694;
  font-size: 20px;
  font-weight: bold;
  line-height: 2.5;
}

.indi-app .indi-card-company-logo-wrapper {
  position: absolute;
  /* float: right; */
  height: 40px;
  width: calc(100% - 30px);
  background-size: 50px 50px;
  background-position: 10px;
  background-size: cover;
  display: flex;
  display: flex;
  justify-content: end;
  top: 16px;
  right: 14px;
}



.indi-app .indi-card-company-logo-wrapper:not(.indi-mini-card-company-logo-wrapper) img {
  max-width: 90%;
}

/* .indi-app div[dir="rtl"] .indi-card-company-logo-wrapper {
  right: 0;
  left: 14px;
} */

/* .indi-app .indi-card-company-logo-wrapper.indi-mini-card-company-logo-wrapper {
  max-width: 50px;
  float: right;
  right: 5px;
} */

.indi-app div[dir="rtl"] .indi-card-company-logo-wrapper.indi-mini-card-company-logo-wrapper {
  float: left;
  right: calc(100% - 55px);
}

.indi-app .indi-ext-card-item-wrapper .indi-card-company-logo-wrapper {
  height: 70px;
  top: 20px;
  right: 12px;
}

.indi-app .indi-ext-card-item-wrapper div[dir="rtl"] .indi-card-company-logo-wrapper {
  right: 0;
  left: 22px;
}

.indi-app .indi-ext-card-item-wrapper .indi-card-upload-picture {
  min-width: 150px;
  min-height: 150px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: 72px;
  margin-bottom: 10px;
}

.indi-app .indi-ext-card-item-wrapper .indi-card-item-parent.card-with-bg {
  padding: 24px;
}

.indi-card-field-item {}

.indi-app .indi-card-select-field-item {
  padding-left: 2px;
}

.indi-app .indi-card-select-field-item option {
  /* color: #000; */
  background-color: #232762;
}

.indi-card-field-item-img {
  min-width: 26px;
  height: 24px;
  margin-right: 8px;
  background-size: contain;
  background-repeat: no-repeat;
}

div[dir="rtl"] .indi-card-field-item-img {
  margin-right: 0px;
  margin-left: 8px;
}

/* .indi-card-field-item-img.indi-card-field-item-phone {
  background-image: url("./../img/fields/phone.png");
}

.indi-card-field-item-img.indi-card-field-item-address {
  background-image: url("./../img/fields/addresses.png");
}

.indi-card-field-item-img.indi-card-field-item-vimeo {
  background-image: url("./../img/fields/vimeo.png");
}

.indi-card-field-item-img.indi-card-field-item-wechat {
  background-image: url("./../img/fields/wechat.png");
}

.indi-card-field-item-img.indi-card-field-item-instagram {
  background-image: url("./../img/fields/instagram.png");
}

.indi-card-field-item-img.indi-card-field-item-youtube {
  background-image: url("./../img/fields/youtube.png");
}

.indi-card-field-item-img.indi-card-field-item-mobile {
  background-image: url("./../img/fields/phone.png");
}

.indi-card-field-item-img.indi-card-field-item-linkedin {
  background-image: url("./../img/fields/linkedin.png");
}

.indi-card-field-item-img.indi-card-field-item-wechat {
  background-image: url("./../img/fields/wechat.png");
}

.indi-card-field-item-img.indi-card-field-item-link {
  background-image: url("./../img/fields/link.png");
}

.indi-card-field-item-img.indi-card-field-item-website {
  background-image: url("./../img/fields/website.png");
}

.indi-card-field-item-img.indi-card-field-item-twitter {
  background-image: url("./../img/fields/twitter.png");
}

.indi-card-field-item-img.indi-card-field-item-email {
  background-image: url("./../img/fields/email.png");
} */

.indi-card-field-item-value {
  color: #fff;
  word-wrap: break-word;
  word-break: break-word;
}

.indi-card-field-item input,
.indi-card-field-item textarea,
.indi-card-field-item select {
  min-width: 190px;
}

.indi-card-field-item input,
.indi-card-field-item textarea,
.indi-card-field-item select,
.indi-card-field-item input:focus-visible,
.indi-card-field-item textarea:focus-visible,
.indi-card-field-item select:focus-visible {
  border: 0;
  background: transparent;
  border-bottom: 1px solid darkgrey;
  color: #fff;
}

.indi-email-form-page.indi-card-field-item input,
.indi-email-form-page.indi-card-field-item textarea {
  margin-bottom: 8px;
}

.indi-card-field-item input:read-only,
.indi-card-field-item input:read-only:focus-visible {
  /* font-style: italic; */
  color: lightgray;
  transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);
}

.indi-card-field-item input:focus-visible {
  border-bottom: 1px solid #dedada;
  outline: none;
}

@media screen and (max-width : 1800px) {
  .indi-app .indi-card-item-wrapper {
    width: 239px;
    min-width: 239px;
  }
}

.indi-card-mini-item-wrapper {
  width: 100%;
}

.indi-app .indi-card-mini-item-wrapper .indi-card-item-parent.card-with-bg {
  border-radius: 10px;
}

.indi-app .indi-card-mini-item-wrapper .indi-info-wrapper {
  border-radius: 10px;
  width: 100%;
  text-align: left;
  margin-top: 40px;
}

.indi-app .indi-card-mini-items-wrapper {
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-y: overlay;
}

.indi-app .indi-card-mini-options-wrapper {
  justify-content: center;
  padding: 8px;
}

.indi-app .indi-card-mini-options-wrapper Button {
  margin: 5px;
}


.indi-app .btn .btn-primary,
.btn.indi-mini-card-selection-btn {
  border-color: #234c8e;
  /* color: #234c8e; */
  color: #fff;
  font-weight: 600;
  border-width: 2px;
}

.indi-app .btn-check:checked+.btn,
.indi-app .btn.active,
.indi-app .btn.show,
.indi-app .btn:first-child:active,
.indi-app :not(.btn-check)+.btn:active,
.indi-app .btn-check:checked+.btn.indi-mini-card-selection-btn {
  background-color: #234c8e;
  border-color: #234c8e;
  color: #fff
}

.btn-group>.btn-group:not(:last-child)>.btn,
.btn-group>.btn.dropdown-toggle-split:first-child,
.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn:last-child:not(.dropdown-toggle) {
  background-color: #ffffff;
  color: #234c8e;
}

/* .indi-app .indi-card-item-wrapper.indi-card-mini-item-wrapper.btn .indi-mini-card-name {
  color: #234c8e;
} */

.indi-app .btn-check+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary {
  background-color: transparent;
  border-radius: 10px;
  outline: none;
  border: 0;
  box-shadow: none;
  transition: all 0.3s ease 0s;
  margin: 16px;
  padding: 0;
  width: 210px;
  max-width: 280px;
  height: 140px;
}


.indi-app .btn-check+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary:hover {
  box-shadow: -2px 6px 14px rgb(0 0 0 / 80%);
}

.indi-app .btn-check:checked+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary {
  box-shadow: -2px 6px 14px rgb(0 0 0 / 80%);
  outline: 2px solid #fff;
  height: 154px;
  padding-bottom: 24px;
  margin-top: 14px;
}

.indi-app .btn-check:checked+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary .indi-mini-card-name {
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.indi-app .indi-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  width: inherit;
  text-overflow: ellipsis;
}

.indi-float-left {
  float: left !important;
}

.indi-float-right {
  float: right !important;
}

.indi-app .indi-card-qr-code {
  width: 32px;
  height: 32px;
  float: right;
  margin-bottom: 4px;
  margin-left: 6px;
}

.indi-app .indi-info-left {
  overflow: hidden;
}

.indi-app .indi-copy-signature-wrapper,
.indi-app .indi-signature-item-wrapper {
  justify-content: center;
  padding: 0 0 24px 0;
  min-height: 230px;
}

.indi-app .indi-mini-card-list {
  margin: 0 auto;
  overflow-x: auto;
  min-height: 200px;
  justify-content: space-between;
}

.indi-app .indi-signature-item-wrapper .indi-signature-item {
  border-radius: 10px;
  min-width: 400px;
  max-width: 400px;
  box-shadow: 0px 1px 6px #000;
  min-height: 192px;
  border: 2px solid transparent;
}

.indi-app .indi-signature-item-wrapper .indi-qrcode-box.row {
  background-color: #fff;
  margin: 0;
  border-radius: 10px;
  position: relative;
}

.indi-app .indi-signature-item-wrapper .indi-signature-item.indi-temp-border-for-email-signature {
  border: 2px solid #ccc;
}

/* .indi-app .indi-signature-item-wrapper .indi-signature-item.indi-temp-border-for-email-signature *{
  background-color: transparent !important;
} */

.indi-app .indi-qrcode-logo {
  border-radius: 10px;
}

.indi-app .indi-qrcode-box-img-col img.indi-qrcode-bg {
  background-size: contain;
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  bottom: 10px;
  right: -2px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 4px 0px #000;
}

.indi-app div[dir="rtl"] .indi-qrcode-box-img-col img.indi-qrcode-bg {
  right: unset;
  left: -2px;
}

.indi-app .indi-qrcode-logo {
  width: 100px;
  height: 100px;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.indi-app .indi-signature-template {
  justify-content: space-between;
  padding: 0 16px;
}

.indi-app .indi-signature-template .indi-qrcode-box-info-col div span {
  display: table-cell;
  padding-bottom: 8px;
  line-height: 18px;
}

.indi-app .indi-qrcode-box-personal-desgination,
.indi-app .indi-qrcode-box-personal-special-text {
  position: relative;
  top: -12px;
  max-width: calc(100% - 56px);
}
.indi-app .indi-qrcode-box-personal-special-text {
  font-style: italic;
  font-weight: 700;
  font-size: 12px;
  margin-top: 4px;
}

.indi-app .indi-signature-template .indi-qrcode-box-info-col div span.indi-card-field-item-img {
  /* background-size: 20PX;
  background-position: 0px 2px;
  background-repeat: no-repeat;
  width: 32px;
  height: 26px;
  background-repeat: no-repeat; */
  padding-bottom: 0;
}

.indi-app .indi-qrcode-qrcode {
  height: 120px;
}

.indi-app .indi-ext-card-details-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-attachment: fixed;
  background-position: right;
  min-height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: contain;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}

.indi-app .indi-ext-card-details-page .indi-globe-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  height: 100vh;
  width: 90%;
  left: -48%;
  top: 0;
  transform: scaleX(-1);
  background-attachment: fixed;
}

.indi-ext-card-item-wrapper {
  justify-content: center;
  width: 442px;
  margin: 0 auto;
  padding: 40px 0;
  height: auto;
}

.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper {
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 3px;
  position: relative;
}

.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page {
  margin: 0 20px;
  width: calc(100% - 40px);
  height: 40vh;
}

.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page .indi-ext-card-error-page-title {
  height: 24px;
  font-size: 24px;
  line-height: 24px;
}

.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page .indi-ext-card-error-page-message {
  margin: 0 auto;
  display: flex;
  /* padding: 50px; */
  width: 100%;
  position: relative;
  justify-content: center;
  height: calc(100% - 24px);
  text-align: center;
  vertical-align: middle;
  /* height: 100%; */
  padding: 100px 0;
  /* color: red; */
}

.indi-app .indi-card-with-actions {
  cursor: pointer;
}

.indi-app .indi-card-with-actions.indi-card-item-parent.card-with-bg:hover {
  box-shadow: 0px 8px 15px rgb(0 0 0 / 60%) !important;
  background-color: transparent;
  outline: none;
  border: 0;
  box-shadow: none;
  transition: all 0.3s ease 0s;
}

.indi-app .indi-card-details-wrapper>div {
  margin-right: 42px;
}

.indi-app .indi-card-item-page2-qrcode-image img {
  height: 100px;
}

.indi-app .indi-card-item-page2 {
  justify-content: space-between;
}

.indi-app .indi-modal-dialog-alert .modal-body {
  padding: 0 !important;
}

.indi-app .indi-modal-dialog-alert-body {
  margin: 0 !important;
}

.indi-app .indi-email-form-page form {
  display: flex;
  flex-direction: column;
}

.indi-app .indi-card-upload-picture-file-input {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  opacity: 0;
  position: absolute;
  height: 100px;
  border: 1px solid red;
  width: 100px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
}

.indi-app .indi-card-upload-picture.indi-card-upload-picture-with-no-bg:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-color: rgb(255, 255, 255, 0.5);
  background-repeat: no-repeat;
  background-size: contain;
  /* transform: rotate(180deg); */
}

.indi-app .indi-card-upload-picture-card-image {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  pointer-events: none;
}

.indi-app .indi-card-upload-picture-with-no-bg:hover {
  cursor: pointer;
}

.indi-app .indi-card-upload-picture-with-no-bg:hover .indi-card-upload-picture-card-image {
  opacity: 0.3;
}

.indi-app .indi-card-upload-picture.indi-card-upload-picture-with-no-bg:hover {
  background-color: rgb(255, 255, 255, 1);
}

.indi-app .indi-card-upload-picture-img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
}

.indi-app .indi-ext-card-item-wrapper .indi-card-upload-picture-img {
  height: 150px;
  width: 150px;
}

.indi-app .indi-table-img-cell {
  width: 24px;
  height: 24px;
}

.indi-app .cropper-crop-box,
.cropper-view-box {
  border-radius: 50%;
}

.indi-app .cropper-view-box {
  box-shadow: 0 0 0 1px #39f;
  outline: 0;
}

.indi-app .cropper-face {
  background-color: inherit !important;
}

.indi-app .cropper-dashed,
.cropper-line {
  display: none !important;
}

.indi-app .cropper-view-box {
  outline: inherit !important;
}

.indi-app .cropper-point.point-se {
  top: calc(85% + 1px);
  right: 14%;
}

.indi-app .cropper-point.point-sw {
  top: calc(85% + 1px);
  left: 14%;
}

.indi-app .cropper-point.point-nw {
  top: calc(15% - 5px);
  left: 14%;
}

.indi-app .cropper-point.point-ne {
  top: calc(15% - 5px);
  right: 14%;
}

.indi-app .indi-crop-dialog-modal-img-wrapper {
  background-color: #2f4696;
  padding: 20px;
  height: 240px;
  border-radius: 5px;
}

.indi-app .indi-crop-card-info-btn {
  height: 28px;
  width: 28px;
  border: 1px solid #fff;
  border-radius: 50%;
  font-style: italic;
  color: #fff;
  text-align: center;
  margin: 10px;
  font-weight: 700;
}

.indi-app .popover .popover-arrow {
  display: none !important;
}

.indi-app .indi-modal-card-crop-btn-wrapper {
  padding: 10px 0;
}

.indi-app .indi-modal-card-crop-btn-wrapper Button {
  margin-right: 5px;
  background-color: #232862;
}

.indi-app .cropper-modal {
  opacity: 1;
  background-color: transparent;
}

.indi-app .indi-add-card-page-badge-ribbon-wrapper,
.indi-app .indi-edit-card-page-badge-ribbon-wrapper {
  width: calc(100% - 150px);
  justify-content: flex-start;
  align-items: flex-start;
  text-align: center;
  padding: 16px;
  display: flex;
  overflow-x: auto;
  overflow-x: overlay;
}

.indi-app .indi-edit-card-page-badge-ribbon-wrapper {
  width: calc(100% - 170px);
}

.indi-app .indi-add-card-page-footer-btn-wrapper {
  width: 150px;
  margin: auto 0;
}

.indi-app .indi-badges-ribbon-wrapper {
  justify-content: center;
}

.indi-app .indi-badge-item-wrapper {
  margin-right: 12px;
  font-size: 12px;
}

.indi-app .indi-badge-item-icon-image {
  width: 24px;
  height: 24px;
}

.indi-app .indi-badge-freeze {
  opacity: 0.5;
  cursor: not-allowed;
}

.indi-app .indi-badge-field-remove {
  font-size: 10px;
  border: 1px solid grey;
  border-radius: 50%;
  height: 18px;
  width: 18px;
  text-align: center;
  color: #abb5d7;
}

.indi-app .indi-badge-field-remove:hover {
  border: 1px solid #fff;
  color: #fff;
  cursor: pointer;
  font-weight: 600;
}


.indi-app .indi-data-table-header {
  background-color: #304697 !important;
  color: #fff !important;
}

.indi-app .indi-data-table-wrapper {
  padding: 16px;
  overflow: auto;
  overflow: overlay;
  height: calc(100% - 32px);
}

.indi-app .indi-add-template-form .indi-data-table-wrapper.indi-text-btn-row {
  justify-content: space-between;
  align-items: center;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .form-floating {
  flex: 1 1;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td {
  vertical-align: middle;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td input[type=checkbox] {
  border-color: #2f4696;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td input[type=text] {
  height: calc(2rem + 2px);
  line-height: 1.25;
  border-color: #2f4696;
  min-width: 200px;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-body {
  overflow: auto;
  padding: 0;
  margin: 16px;
  font-weight: bold;
  color: #304697;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-item .accordion-button {
  color: #2f4594;
  font-weight: bold;
}

.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-item .accordion-button:not(.collapsed) {
  background-color: #2b5daf40;
  font-weight: bold;
  color: #232862;
}

.indi-app .indi-add-template-form .indi-add-card-title {
  height: 46px;
}

.indi-app .indi-add-page-footer-btn-wrapper.float-right {
  float: right;
}

.indi-app tr.indi-data-table-tr {
  background-color: #f5f8fc;
  border-top: 5px solid #f0f3f9;
  color: #304697;
  font-size: 13px;
  font-weight: 600;
}

.indi-app .indi-data-table-checkbox-all {
  opacity: 0;
}

.indi-app .indi-table-header-searchbox {
  width: 50px;
}

.indi-app .indi-tamplte-empty-field-value {
  font-size: 14px;
  color: darkgrey;
  font-style: italic;
}

.indi-app .indi-email-signature-footer {
  justify-content: right;
  display: flex;
  margin: 0 10px 10px 0;
}

.indi-app .indi-email-signature-footer Button {
  background-color: #2f4696;
  border-color: #2f4696;

}

/* indi-add-form-item-input */
.indi-app .indi-img-preview {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-size: contain !important;
  background-repeat: no-repeat;
}

.indi-app .indi-img-preview.indi-dark-img-preview {
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.indi-app .indi-add-form-wrapper {
  justify-content: start;
  min-height: 300px;
  height: calc(100vh - 200px);
  overflow-y: auto;
}

.indi-app .indi-upload-picture-file-input {
  opacity: 0;
  position: absolute;
}

.indi-app .indi-data-table-td-template-image .indi-upload-picture-file-input {
  left: 0;
}


.indi-app .indi-add-img-wrapper {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-color: rgb(255, 255, 255, 0.5);
  background-repeat: no-repeat;
  background-size: contain;
}

.indi-app .indi-upload-picture-file-input,
.indi-app .indi-add-img-wrapper {
  width: 72px;
  height: 58px;
  border: 1px solid transparent;
  border-radius: 6px;
  margin: 0 20px;
  cursor: pointer;
}

.indi-app .indi-data-table-tr .indi-upload-picture-file-input,
.indi-app .indi-data-table-tr .indi-add-img-wrapper {
  margin: 0;
}

.indi-app .form-floating>.form-control-plaintext~label,
.indi-app .form-floating>.form-control:focus~label,
.indi-app .form-floating>.form-control:not(:placeholder-shown)~label,
.indi-app .form-floating>.form-select~label {
  opacity: 1;
  background: #fff;
  width: auto;
  transform: scale(.85) translateY(-0.8rem) translateX(0.5rem);
  height: auto;
  color: #2f4696;
  padding: 0 4px;
  margin: 0 8px;
}

.indi-app .form-floating>.form-control,
.indi-app .form-floating>.form-control-plaintext,
.indi-app .form-floating>.form-select {
  height: calc(2rem + 2px);
  line-height: 1.25;
  border-color: #2f4696;
  padding: 1rem;
}

.indi-app .form-floating>.form-select.indi-multi-input-select-field {
  height: 100px;
}

.indi-app .form-floating>textarea.form-control {
  height: auto;
}

.indi-app .form-floating>.form-select {
  height: 28px;
  margin-top: 8px;
  padding-right: 40px;
}

.indi-app .indi-empty-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
  font-size: 18px;
  border: 1px solid;
  margin: 16px;
}

.indi-app .form-floating>.form-control.indi-input-textarea-field {
  height: 90px;
}


.indi-app .form-floating>.form-control-plaintext:focus,
.indi-app .form-floating>.form-control-plaintext:not(:placeholder-shown),
.indi-app .form-floating>.form-control:focus,
.indi-app .form-floating>.form-control:not(:placeholder-shown),
.indi-app .form-floating>.form-select {
  /* padding-top: 0; */
  padding-top: 3px;
  padding-bottom: 0;
  border-color: #2f4696;
}

.indi-app .form-floating>textarea.form-control:not(:placeholder-shown) {
  padding-top: 10px;
}

.indi-app .form-floating>label {
  padding: 0.25rem 1rem;
  color: #2f4696;
}

.indi-app .form-control:focus,
.indi-app .form-select:focus {
  box-shadow: 0 0 0 2px rgb(13 110 253 / 20%);
}

.indi-app .indi-add-form-item {
  margin: 12px 0;
}

.indi-app .indi-add-form-item-label {
  color: #2f4696;
  font-weight: bold;
  flex: 1 0;
}


.indi-app .indi-add-template-badge-icon-image {
  width: 24px;
  height: 24px;
}

.indi-app .indi-add-img-wrapper-preview {
  width: 32px;
}

.indi-app .indi-data-table-td-template-image {
  display: flex;
  justify-content: center;
}

.indi-app .indi-data-table-td-template-img-prevew {
  background-color: rgba(0, 0, 0, 0.1);
}

.indi-app .indi-upload-picture-file-input-wrapper {
  position: relative;
}

.indi-app .indi-template-field-item-img {
  min-width: 26px;
  height: 24px;
  margin-right: 8px;
  background-repeat: no-repeat !important;
  background-size: contain !important;
}

.indi-app .indi-add-card-template-preview {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
}

.indi-app .indi-add-card-template-preview-wrapper {
  justify-content: center;
}

.indi-app .indi-add-card-template-cell {
  vertical-align: middle;
}

.indi-app .indi-card-template-preview-wrapper {
  max-height: 500px;
  overflow: auto;
  overflow: overlay;
}


.indi-app .indi-user-settings-page-wrapper {
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-y: overlay;
}

.indi-app .indi-user-settings-page-card {
  width: 220px;
  min-width: 220px;
  margin: 16px;
  /* border-radius: 10px; */
  padding: 0;
  background: #fff;
  /* box-shadow: 0px 1px 6px #000; */
  min-height: 192px;
}

.indi-app .indi-user-settings-page-card-inner {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  width: 100%;
  /* height: 100%; */
  flex-direction: column;
  cursor: pointer;
}

.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner {
  flex-direction: row;
  background-color: #5e6aae69;
  padding: 5px 10px;
}

.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-profile-wrapper {
  max-height: 150px;
  overflow: auto;
  overflow: overlay;
}

.indi-app .indi-user-settings-page-profile .indi-user-profile-delete-btn {
  top: 0;
}

.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner.indi-user-settings-page-card-inner-profile {
  margin: 2px 0;
}

.indi-app .indi-user-settings-add-profile-btn {
  font-weight: bold;
  color: #2f4694;
  line-height: 18px;
  padding-left: 5px;
  font-size: 16px;
  top: 10px;
}


.indi-app .indi-user-settings-add-profile-btn:hover {
  cursor: pointer;
}

.indi-app .indi-user-settings-page-card-header {
  padding: 12px 8px 20px 8px;
  position: relative;
}

.indi-app .indi-user-settings-page-card-header-img {
  width: 16px;
  height: 16px;
}

.indi-app .indi-user-settings-page-image {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.indi-app .indi-user-settings-page-change-email {
  flex-direction: column;
  cursor: default;
}

.indi-app .indi-user-settings-page-card-header-label {
  font-weight: bold;
  color: #2f4694;
  line-height: 18px;
  padding-left: 5px;
  font-size: 12px;
}

.indi-app .indi-user-settings-page-card-inner-item {
  /* background-color: #f0f3f9; */
  width: 100%;
  padding: 5px 10px;
}

.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password {
  /* background-color: transparent; */
  line-height: 34px;
}

.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password,
.indi-app .indi-user-settings-page-card-inner-item {
  background-color: transparent;
}

.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner:hover,
.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password:hover,
.indi-app .indi-user-settings-page-card-inner-item:hover {
  background-color: #23286236;
}

.indi-app .indi-user-settings-page-change-email-label {
  font-weight: 500;
}

.indi-app .indi-user-settings-page-change-email-value {
  font-size: 12px;
  word-break: break-all;
}

.indi-app .indi-user-settings-page-display-name {
  margin-left: 7px;
}

.indi-modal-edit-user-profile-resetpassword-section:not(.indi-modal-edit-user-profile-resetpassword),
.indi-modal-edit-user-profile-profile-section:not(.indi-modal-edit-user-profile-profile),
.indi-modal-edit-user-profile-email-section:not(.indi-modal-edit-user-profile-email) {
  display: none;
}

.indi-app .indi-modal-edit-user-profile-floating-inputs {
  margin-bottom: 20px;
}

.indi-app .indi-modal-edit-user-profile-header-title {
  color: #2f4694;
}

.indi-app .indi-user-profile-settings-error-msg {
  left: 12px;
  position: absolute;
  bottom: 20px;
  max-width: 270px;
  color: red;
}

.indi-app .indi-card-upload-picture-file-input-wrapper {
  min-width: 100px;
  min-height: 100px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: 40px;
  max-width: 100px;
  max-height: 100px;
  overflow: hidden;
}

.indi-app .indi-card-upload-picture-file-input-wrapper:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-color: rgb(255, 255, 255, 0.5);
  background-repeat: no-repeat;
  background-size: contain;
}

.indi-app .indi-card-upload-picture-img-input {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  opacity: 1;
  position: absolute;
  height: 100px;
  border: 1px solid #232862;
  width: 100px;
  border-radius: 50%;
  cursor: pointer;
}

.indi-app .indi-card-upload-picture-file-input-wrapper:hover .indi-card-upload-picture-img-input {
  opacity: 0.5;
}

.indi-app .modal-header .modal-title.h4 {
  color: #2f4694;
  font-size: 18px;
}

.indi-app .indi-modal-addr-preview-contact-number-wrapper {
  display: flex;
  justify-content: end;
}

.indi-app .indi-modal-addr-preview-full-address {
  width: 100%;
  height: 70px;
  border: 1px solid grey;
  border-radius: 3px;
  background-color: #d3d3d340;
  margin-top: 18px;
  padding: 5px 10px;
  font-size: 14px;
  font-style: italic;
}

.indi-app .indi-modal-addr-preview-contact-number {
  font-size: 12px;
  font-weight: 700;
  line-height: 28px;
  margin-left: 10px;
}

.indi-app .indi-select-address-modal-body {
  padding-bottom: 0;
}

.indi-app .indi-select-address-modal-footer {
  display: flex;
  justify-content: end;
  align-items: center;
}

.indi-app .indi-add-card-select-address-field {
  font-style: italic;
  background-color: #d3d3d340;
}

.indi-app .indi-add-card-address-telephone-wrapper {
  display: flex;
  justify-content: flex-end;
}

.indi-app .indi-add-card-address-telephone {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  display: inline-flex;
  background-size: contain;
  background-repeat: no-repeat;
}

.indi-app .indi-add-card-address-telephone-value {
  font-size: 12px;
  font-style: italic;
  color: #ccc;
}


.indi-app .indi-card-address-text {
  line-height: 18px;
  /* font-style: italic; */
  font-size: 14px;
}

.indi-app .indi-card-number-text {
  margin-top: 5px;
  font-size: 12px;
  display: flex;
}

.indi-app .indi-email-sign-generate-item {
  /* border-left: 1px solid blue; */
  padding-bottom: 14px;
}

.indi-app .indi-email-sign-generate-item,
.indi-app .indi-email-sign-generate-body {
  padding-left: 28px;
  position: relative;
}


.indi-app .indi-email-sign-vertical-line::before {
  background-color: #304697;
  bottom: 0px;
  content: "";
  left: 0;
  position: absolute;
  top: 0px;
  transform: translateX(-50%);
  width: 2px;
}

.indi-app .indi-email-sign-generate-item:first-child .indi-email-sign-vertical-line::before {
  top: 10px;
}

.indi-app .indi-email-sign-generate-item:last-child .indi-email-sign-vertical-line::before {
  height: 18px;
  bottom: auto;
}

.indi-app .indi-email-sign-vertical-line::after {
  background-color: #304697;
  border-radius: 50%;
  content: "";
  height: 14px;
  left: 0;
  position: absolute;
  top: calc(0.75rem);
  transform: translateX(-50%) translateY(-50%);
  width: 14px;
}



.indi-app .indi-email-sign-help-heading {
  font-size: 12px;
  font-weight: 700;

}

.indi-app .indi-email-sign-help-link {
  font-size: 16px;
}

.indi-app .indi-email-sign-help-link>a {
  text-decoration: none;
  line-height: 14px;
  display: block;
  color: #304697;
}

.indi-app .indi-email-sign-tab-content-right-side-area {
  max-width: 400px;
}

.indi-app .indi-email-sign-tab-panel-heading {
  font-weight: 700;
  font-size: 14px;
}

.indi-app .indi-email-sign-tab-panel-sub-heading {
  font-size: 10px;
}

.indi-app .nav-pills .nav-link {
  background-color: transparent;
  color: #304697;
}

.indi-app .nav-pills .nav-link.active {
  background-color: #304697;
  color: #fff;
}

.indi-app .indi-temp-dummy {
  position: fixed;
  top: 0;
  left: 0;
  image-rendering: pixelated;
}

.indi-app .indi-email-sign-copy-clipboard-img-wrapper {
  max-width: 400px;
  max-height: 225px;
  position: relative;
  display: block;
  image-rendering: pixelated;
}

.indi-app .indi-email-sign-copy-clipboard-img-wrapper img {
  image-rendering: pixelated;
}

.indi-app .indi-temp-dummy-img {
  height: 100px;
  width: 200px;
}

.indi-app .indi-email-sign-copied-to-clipboard-alert {
  position: fixed;
  top: 5px;
  z-index: 1;
}

.indi-app .indi-temp-dummy-img img {
  height: 150px;
  width: 275px;
  border-radius: 10px;
  box-shadow: 0px 1px 6px #000;
}

.indi-app .indi-add-card-name-input,
.indi-app .indi-add-card-custom-id-input,
.indi-app .indi-add-card-profile-input {
  min-width: 250px;
}

.indi-app .indi-card-form-error .indi-add-card-custom-id-input {
  color: red;
  border-bottom-color: red;
}

.indi-app .indi-bulk-upload-img {
  width: 24px;
  height: 24px;
  margin: 0 8px;
}

.indi-app .indi-bulk-upload-file-name.indi-img-preview {
  width: 100%;
}

/* .indi-app .indi-card-ext-footer-btn {
  position: absolute;
  bottom: 4px;
  width: 400px;
  justify-content: flex-end;
  display: flex;
} */

.indi-app .indi-card-ext-footer-btn img {
  width: 32px;
  height: 32px;
  margin: 0 0 10px 10px;
}

/* 
.indi-app .indi-card-ext-footer-btn img:last-child {
  margin-left: 10px;
}
 */
.indi-app .indi-mini-card-list .indi-mini-card-badge-icons-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  max-width: 200px;
}
.indi-app .indi-mini-card-list .indi-mini-card-badge-icon {
  width: 14px;
  margin: 3px;
}

.indi-app .indi-signature-item-wrapper .indi-mini-card-badge-icon {
  width: 20px;
  height: 20px;
  margin: 4px;
}

.indi-app .indi-ext-card-social-link {
  color: #fff;
}

.indi-app .indi-apply-dark-background {
  /* background-color: rgba(0, 0, 0, 0.5); */
  background-color: rgba(48, 82, 158, .5);
}

.indi-app .indi-disable-action-icon {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.indi-app .indi-card-external-badge-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: end;
}

.indi-app .indi-card-external-badge-wrapper img {
  display: flex;
  flex-direction: row;
  height: 16px;
  width: 16px;
  margin-left: 6px;
}

.indi-app .indi-send-email-form-disable {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}

.indi-tick-mark {
  position: relative;
  /* display: inline-block; */
  width: 14px;
  height: 14px;
  margin: 0 auto;
}

.indi-tick-mark::before,
.indi-tick-mark::after {
  position: absolute;
  left: 0;
  /* #409933 */
  background-color: #9acd32;
  content: "";
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
  /* opacity: 0.5; */
}

.indi-tick-mark::before {
  top: 50%;
  height: 50%;
  width: 3px;
}

.indi-tick-mark::after {
  bottom: 0;
  height: 3px;
  width: 100%;
}

.indi-tick-mark.indi-double-tick-mark::before,
.indi-tick-mark.indi-double-tick-mark::after {
  opacity: 1;
  background-color: #336699;
}

.indi-app .indi-range-input {
  padding-top: 29px;
}

.tooltip {
  pointer-events: none !important;
}


.indi-app .fade.show.bs-tooltip-bottom {
  transform: translate(0px, 0px);
  inset: 0px auto auto 0px;
  position: absolute;
}

.indi-app .bs-tooltip-bottom .tooltip-arrow::before {
  border-bottom-color: #304697;
}

.indi-app .tooltip-inner {
  background-color: #304697;
}

.indi-app .indi-up-arrow,
.indi-app .indi-down-arrow {
  /* background: url("../img/arrow.png") no-repeat; */
  height: 10px;
  width: 20px;
  background-size: contain;
  cursor: pointer;
  opacity: 0;
  margin-left: 2px;
}

.indi-app .indi-card-field-item:hover .indi-up-arrow,
.indi-app .indi-card-field-item:hover .indi-down-arrow {
  opacity: 1;
}

.indi-app .indi-down-arrow {
  /* -webkit-transform: scaleY(-1);
  transform: scaleY(-1); */
}

.indi-app .indi-arrow {
  border: solid #fff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.indi-app .indi-right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.indi-app .indi-left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.indi-app .indi-up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.indi-app .indi-down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.indi-app .indi-reset-user-password-list-item {
  margin-left: 10px;
}

.indi-app .indi-users-table-region-dropdown {
  min-width: 75px;
  width: auto;
  max-width: 135px;
}

.indi-app .indi-email-signature-empty-page {
  margin: 0 auto;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  display: flex;
  position: relative;
  top: calc(50% - 18px);
}

.indi-app .indi-card-item-page2-qrcode-download-image-wrapper {
  /* background-color: rgba(255, 255, 255, 0.5); */
  max-height: 72px;
}

.indi-app .indi-card-item-page2-qrcode-download-image {
  margin-left: 5px;
  font-size: 12px;
  color: #ccc;
}

.indi-app .indi-card-item-page2-qrcode-download-image:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
}

.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-small {
  width: 16px;
  width: 16px;
}

.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-medium {
  width: 32px;
  width: 32px;
}

.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-large {
  width: 64px;
  width: 64px;
}

.indi-app .btn.show.indi-header-userprofile-btn {
  background-color: transparent;
}
.indi-app .indi-analytics-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
}
.indi-app .indi-input-field.indi-color-input-field {
  border: none;
  background-color: transparent;
  width: 38px;
  margin-left: 5px;
}

.indi-joint-image {
  position: relative;
  width: 50%;
  max-width: 50%;
}

.indi-joint-image img {
  position: relative;
  height: 40px;
}

.indi-joint-left-image img {
  float: left;
  left: 0;
}

.indi-app div[dir="rtl"] .indi-joint-left-image img {
  float: right;
  right: 0;
}

.indi-joint-right-image img {
  float: right;
  right: 0;
}

.indi-app div[dir="rtl"] .indi-joint-right-image img {
  float: left;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/indi.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX,uDAAuD;;AAEvD;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;EAEE,6BAA6B;EAC7B,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,0CAA0C;;AAE1C,qDAAqD;;AAErD;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,MAAM;EACN,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;;;;EAIE;;AAEF,eAAe;AACf;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6DAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,6DAA2D;EAC3D,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAAyD;EACzD,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;;AAErB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,aAAa;;;AAGb,aAAa;;AAEb;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;;AAE9C;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA,WAAW;;AAEX,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB,eAAe;AACf;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;;AAGA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA,aAAa;;;AAGb;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;;;;;EAKE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yDAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,yDAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;;;AAIA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkDG;;AAEH;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;EAME,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAKhB,uEAAuE;AACzE;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;;AAGA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;;;;EAIE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;;;;;iCAK+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yDAA2C;EAC3C,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,UAAU;EACV,UAAU;EACV,MAAM;EACN,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yDAA0C;EAC1C,yCAAyC;EACzC,4BAA4B;EAC5B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;;AAEvB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;;AAGA;EACE,yDAA2C;EAC3C,yCAAyC;EACzC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;;;EAIE,UAAU;EACV,gBAAgB;EAChB,WAAW;EAEX,4DAA4D;EAC5D,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;;;;;EAKE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,yDAAuC;EACvC,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yDAA0C;EAC1C,yCAAyC;EACzC,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0DAAuD;EACvD,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;AACb;;;;AAIA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;;EAIE;AACF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mDAAmD;EACnD,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;0BACwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;AACT","sourcesContent":[".indi-app {}\n\n/* Begin :  custom style for native browser scroll bar*/\n\nbody.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar,\n.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar {\n  width: 16px;\n  height: 16px;\n}\n\nbody.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar {\n  background: rgba(255, 255, 255, 1);\n}\n\n.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar:hover {\n  background: rgba(255, 255, 255, 0);\n}\n\n.indi-app:not(.indi-app-on-macintosh) *:hover::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\nbody.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb,\n.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 6px solid transparent;\n  min-height: 50px;\n  background-color: transparent;\n}\n\nbody.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb {\n  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);\n}\n\nbody.indi-app:not(.indi-app-on-macintosh):hover::-webkit-scrollbar-thumb,\n.indi-app:not(.indi-app-on-macintosh) *:hover::-webkit-scrollbar-thumb {\n  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);\n}\n\n.indi-app:not(.indi-app-on-macintosh) .indi-app-dark-area:hover::-webkit-scrollbar-thumb {\n  -webkit-box-shadow: inset 16px 16px 0px rgba(255, 255, 255, 0.75);\n}\n\nbody.indi-app:not(.indi-app-on-macintosh)::-webkit-scrollbar-thumb:hover,\n.indi-app:not(.indi-app-on-macintosh) *::-webkit-scrollbar-thumb:hover {\n  border: 4px solid transparent;\n  -webkit-box-shadow: inset 16px 16px 0px rgb(128 130 133);\n  background-color: transparent;\n}\n\n.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area:hover::-webkit-scrollbar-thumb,\n.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area::-webkit-scrollbar-thumb:hover {\n  -webkit-box-shadow: inset 16px 16px 0px #eeeeee;\n}\n\n.indi-app .indi-app-normal-scrolling {\n  overflow-x: auto;\n  overflow-y: auto;\n  overflow: auto !important;\n  overflow: overlay !important;\n}\n\n.indi-app:not(.indi-app-on-macintosh) .indi-app-normal-scrolling {\n  scrollbar-width: thin;\n  scrollbar-color: rgb(128 130 133) transparent;\n}\n\n.indi-app:not(.indi-app-on-macintosh) *.indi-app-dark-scrollable-area:hover {\n  scrollbar-color: #eeeeee transparent;\n}\n\n.indi-app .indi-app-normal-scrolling {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/*TODO: Will be moved to hisos side - End*/\n\n/* End :  custom style for native browser scroll bar*/\n\n.indi-app .indi-company-logo {\n  background: #1fc;\n}\n\n.indi-app .indi-header .indi-company-logo {\n  background: #ffc;\n}\n\n.indi-app .indi-footer .indi-company-logo {\n  background: #ffc;\n}\n\n.indi-app .indi-global-mask {\n  position: absolute;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0;\n  z-index: 99998;\n}\n\n.indi-app .indi-global-mask .indi-global-mask-loading-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #fff;\n  font-weight: 700;\n  height: 100%;\n  width: 100%;\n}\n\n.indi-app .indi-global-mask .indi-global-mask-loading-text .indi-global-mask-loading-text-message {\n  margin-left: 9px;\n}\n\n.indi-app .indi-hidden {\n  display: none !important;\n  visibility: hidden !important;\n}\n\n/* TEMP changes */\n/* .indi-app .indi-header-wrapper {\n  background-color: lightseagreen;\n  display: flex;\n}\n */\n\n/*Header start*/\n.indi-app .indi-header-wrapper {\n  height: 100px;\n}\n\n.indi-app .indi-header-left-logo-wrapper,\n.indi-app .indi-header-right-bg-wrapper>div {\n  display: flex;\n  align-items: center;\n}\n\n.indi-app .btn.indi-header-userprofile-btn:first-child:active {\n  background-color: #fff;\n  border-radius: 50%;\n}\n\n.indi-app .indi-logo {\n  background: url(\"../img/company-logo.png\") no-repeat;\n  height: 80px;\n  width: 140px;\n  background-size: contain;\n}\n\n.indi-app .indi-header-right-bg {\n  background: url(\"../img/sos-header-right-bg.png\") no-repeat;\n  height: 100px;\n  width: 69px;\n  margin-right: 41px;\n  background-size: contain;\n}\n\n.indi-app .indi-header-wrapper .btn {\n  padding: 0;\n}\n\n.indi-app .indi-notification-icon {\n  background: url(\"../img/notification_icon.png\") no-repeat;\n  width: 19px;\n  height: 22.5px;\n  background-size: contain;\n  margin: 0.5rem 1rem;\n\n}\n\n.indi-app .indi-header-profile-image {\n  height: 26px;\n  width: 26px;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.indi-header-user-profile-firstname {\n  margin: 0 6px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.indi-app .container {\n  max-width: 100%;\n}\n\n/*Header end*/\n\n\n/*Body start*/\n\n.indi-app .indi-body-wrapper {\n  background-color: lightskyblue;\n  height: calc(100vh - 180px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: #2f4594;\n}\n\n.indi-app .indi-full-height {\n  background: #fff;\n  flex: 1 1 auto;\n  padding: 0 12px;\n  height: 100%;\n}\n\n.indi-app .indi-badge-add-button-wrapper {\n  background-color: #1fc;\n}\n\n.indi-app .indi-badge-list-wrapper {\n  background-color: rgb(15, 130, 159);\n}\n\n.indi-app .indi-tile {\n  flex: 1 1 auto;\n  background: green;\n  height: calc(100% - 80px);\n  width: 25%;\n  padding: 16px;\n  margin: 16px;\n  margin-bottom: 64px;\n}\n\n.indi-app .indi-navmenu-item {\n  display: flex;\n  /* padding: 8px; */\n  /* border: 1px solid gray; */\n}\n\n.indi-app .indi-navmenu-item .indi-navmenu-active,\n.indi-app .indi-navmenu-item .indi-navmenu-inactive {\n  background: transparent;\n  padding: 8px;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n  display: flex;\n  height: 56px;\n  align-items: center;\n}\n\n.indi-app .indi-navmenu-item .indi-navmenu-inactive:hover {\n  background: #23286236;\n}\n\n.indi-app .indi-navmenu-item .indi-navmenu-active {\n  background: #304697;\n  /* background: #3a52a7; */\n  color: #fff;\n  font-weight: bold;\n}\n\n.indi-app .indi-left-navigation-wrapper {\n  padding-top: 20px;\n  border-radius: 6px;\n  height: 100%;\n}\n\n.indi-app .indi-left-navigation-wrapper,\n.indi-app .indi-content-area-wrapper {\n  background: #f0f3f9;\n  overflow-y: auto;\n  overflow-y: overlay;\n}\n\n.indi-app .indi-content-area-wrapper {\n  border-radius: 6px;\n  padding: 20px;\n}\n\n.indi-app .indi-content-area-wrapper .indi-add-card-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.indi-app .indi-content-area-wrapper .indi-add-card-wrapper .indi-card-item-parent.card-with-bg {\n  max-width: 300px;\n  min-width: 240px;\n  margin: 0 auto;\n}\n\n.indi-app .indi-content-area-wrapper button.btn.btn-primary,\n.indi-app .modal-dialog button.btn.btn-primary {\n  /* float: right; */\n  margin: 12px 0 12px 8px;\n  background-color: #232862;\n  border: 1px solid #232862;\n}\n\n.indi-app .indi-content-area-wrapper form {\n  height: 100%;\n  width: 100%;\n}\n\n.indi-app img.indi-w-32 {\n  width: 32px;\n  margin: 4px 16px;\n  color: #010fb8;\n}\n\n.indi-app .indi-content-area-wrapper img.indi-w-20 {\n  margin: 8px;\n  color: #010fb8;\n}\n\n.indi-app a.indi-navmenu-inactive span {\n  color: #010fb8;\n}\n\n.indi-app .indi-navmenu-active img.indi-w-32 {}\n\n.indi-app .indi-qrcode-box-img-col {\n  position: relative;\n}\n\n.indi-app .indi-qrcode-box-img-col img {\n  background-color: #2f45947a;\n  width: 40px;\n  height: 29px;\n}\n\n.indi-app .indi-qrcode-box-img-col img.indi-qrcode-qrcode {\n  width: 100px;\n  height: 100px;\n}\n\n/*utility classes*/\n.indi-place-me-top-right {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.indi-place-me-top-left {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n\n.indi-place-me-bottom-right {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n}\n\n.indi-qrcode-box-codes {\n  position: absolute;\n  bottom: 2px;\n  right: -12px;\n}\n\ndiv[dir=\"rtl\"] .indi-qrcode-box-codes {\n  right: unset;\n  left: -12px;\n}\n\n.indi-wrap-overflow-icons {\n  max-width: calc(100% - 90px);\n  border-bottom: 10px solid #fff;\n}\n\n.indi-place-me-bottom-left {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n\n/*Body end*/\n\n/*popover style start*/\n.indi-app .popover-body {\n  color: #2f4694;\n}\n\n/*popover style end*/\n\n/*footer start*/\n.indi-app .indi-add-card-item-footer {\n  box-shadow: 0px 0px 4px 0px #46516f;\n  margin-top: 10px;\n}\n\n.indi-app .indi-footer-wrapper {\n  background-color: #ffffff;\n  font-weight: bold;\n  height: 80px;\n  color: #2f4694;\n}\n\n.indi-app .indi-footer-wrapper .indi-logo {\n  height: 48px;\n  width: 84px;\n}\n\n.indi-app .indi-footer-wrapper .indi-footer-logo-wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  font-size: 6px;\n}\n\n\n.indi-app .indi-footer-wrapper .indi-footer-logo,\n.indi-app .indi-footer-wrapper .indi-footer-logo-text {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  padding: 0;\n  margin: 0 24px;\n}\n\n.indi-app .indi-footer-wrapper .navbar-nav {\n  margin: 0 0 0 24px;\n}\n\n.indi-app .indi-footer-wrapper .navbar-nav-left .nav-link {\n  margin: 0 4px;\n  color: #2f4694;\n  font-size: 12px;\n}\n\n.indi-app .indi-footer-wrapper .indi-copy-text {\n  font-weight: bold;\n  font-size: 11px;\n  line-height: 15px;\n  margin: 0 48px;\n  padding-bottom: 5px;\n}\n\n.indi-app .indi-w-20 {\n  width: 16px;\n  height: 16px;\n  margin: 0px;\n}\n\n/*Footer end*/\n\n\n.indi-app .indi-body2-wrapper {\n  padding: 20px;\n}\n\n.indi-app .indi-body-cards-wrapper {\n  flex-flow: column;\n}\n\n.indi-app .indi-body-action-bar,\n.indi-app .indi-add-card-title {\n  display: flex;\n  flex-flow: row;\n  justify-content: space-between;\n}\n\n.indi-app .indi-body-title,\n.indi-app .indi-body-action-bar,\n.indi-app .indi-add-card-title,\n.indi-app .indi-user-settings-page-header,\n.indi-app .indi-signature-title {\n  font-weight: bold;\n  color: #2f4694;\n  line-height: 40px;\n  padding: 0 16px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indi-app .indi-signature-title {\n  border-top: 10px solid #fff;\n  border-radius: 10px;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-logo-image {\n  padding: 0;\n  border: 4px solid #232862;\n  border-radius: 6px 0 0 6px;\n  margin-top: 6px;\n  margin-right: -14px;\n  background-color: #232862;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-logo-image {\n  padding: 0;\n  border: 4px solid #232862;\n  border-radius: 6px 0 0 6px;\n  margin-top: 6px;\n  margin-right: -14px;\n  background-color: #232862;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-joint-logo-image {\n  border-radius: 0;\n}\n\n.indi-app .indi-qrcode-logo-images-wrapper {\n  right: 0;\n  position: absolute;\n  width: 16.5%;\n}\n\n.indi-app .indi-logo-img-wrapper-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 14px;\n  width: 30.5%;\n}\n\n.indi-app .indi-qrcode-logo-images-wrapper .indi-logo-image {\n  flex: 1;\n}\n\n.indi-app div[dir=\"rtl\"].indi-signature-item-wrapper .indi-qrcode-logo-images-wrapper {\n  right: unset;\n  left: 0;\n}\n.indi-app div[dir=\"rtl\"].indi-signature-item-wrapper .indi-logo-image {\n  border-radius: 0 6px 6px 0;\n  margin-right: 0;\n  margin-left: -14px;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-logo-image img {\n  width: 100%;\n  background-color: #232862;\n}\n\n.indi-app .indi-body-actions {\n  display: flex;\n  flex-flow: row;\n  justify-content: end;\n}\n\n.indi-app .indi-body-action {\n  margin-left: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.indi-app .indi-add-card-wrapper,\n.indi-app .indi-content-area-wrapper,\n.indi-app .indi-cards-collection-wrapper {\n  height: calc(100% - 32px);\n  padding: 0;\n  overflow-x: auto;\n  overflow-x: overlay;\n}\n\n.indi-app .indi-placeholder-add-card.indi-card-item-wrapper {\n  border: 2px dashed #2d326c;\n  border-radius: 10px;\n  flex-flow: column;\n  padding: 10px;\n}\n\n.indi-app .indi-card-item-wrapper {\n  width: 300px;\n  min-width: 300px;\n  cursor: pointer;\n  margin: 16px;\n  position: relative;\n}\n\n.indi-app .indi-card-item-parent {\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  background-size: cover;\n}\n\n.indi-app .indi-card-item-parent.card-with-bg {\n  /* background-image: url(\"../img/Card.png\"); */\n  padding: 16px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  position: relative;\n}\n\n.indi-app .indi-card-template-item-wrapper {\n  background-color: rgba(255, 255, 255, 0.5);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  /* z-index: -1; */\n}\n\n.indi-app .indi-card-template-item-wrapper:hover {\n  opacity: 1;\n}\n\n.indi-app .indi-card-template-item-wrapper .indi-item-edit-overlay,\n.indi-app .indi-card-template-item-wrapper .indi-item-delete-overlay {\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n}\n\n.indi-app .indi-card-template-item-wrapper .indi-item-edit-overlay {\n  background-image: url(\"../img/Edit.png\");\n  top: calc(50% - 150px);\n}\n\n.indi-app .indi-card-template-item-wrapper .indi-item-delete-overlay {\n  background-image: url(\"../img/Delete.png\");\n  top: calc(50% - 100px);\n}\n\n.indi-app .indi-card-upload-picture {\n  min-width: 100px;\n  min-height: 100px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  margin-top: 52px;\n  margin-bottom: 10px;\n  max-width: 100px;\n  max-height: 100px;\n  overflow: hidden;\n}\n\n.indi-app .indi-card-fields {\n  overflow-y: auto;\n  overflow-y: overlay;\n  width: inherit;\n  margin-bottom: 36px;\n}\n\n.indi-app .indi-card-name {\n  text-align: center;\n}\n\n.indi-app .indi-card-name.indi-mini-card-name {\n  text-align: left;\n}\n\n.indi-app .indi-template-title,\n.indi-app .indi-card-title {\n  padding-bottom: 0px;\n  line-height: 19px;\n  min-height: 20px;\n  max-height: 40px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.indi-app .indi-card-title.indi-mini-card-title {\n  font-size: 10px;\n  text-align: left;\n}\n\n.indi-app div[dir=\"rtl\"] .indi-card-title.indi-mini-card-title {\n  text-align: right;\n}\n\n.indi-app .indi-template-title {\n  font-weight: bold;\n}\n\n.indi-app .indi-card-field-wrapper>div {\n  padding-bottom: 16px;\n}\n\n.indi-app .indi-placeholder-add-card-img {\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n\n.indi-app .indi-placeholder-add-card:hover {\n  background-color: #dbe2fa;\n}\n\n.indi-app .indi-placeholder-add-card-img img {\n  height: 72px;\n  width: 72px;\n}\n\n.indi-app .indi-placeholder-add-card-text {\n  justify-content: center;\n  align-items: center;\n  color: #2f4694;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 2.5;\n}\n\n.indi-app .indi-card-company-logo-wrapper {\n  position: absolute;\n  /* float: right; */\n  height: 40px;\n  width: calc(100% - 30px);\n  background-size: 50px 50px;\n  background-position: 10px;\n  background-size: cover;\n  display: flex;\n  display: flex;\n  justify-content: end;\n  top: 16px;\n  right: 14px;\n}\n\n\n\n.indi-app .indi-card-company-logo-wrapper:not(.indi-mini-card-company-logo-wrapper) img {\n  max-width: 90%;\n}\n\n/* .indi-app div[dir=\"rtl\"] .indi-card-company-logo-wrapper {\n  right: 0;\n  left: 14px;\n} */\n\n/* .indi-app .indi-card-company-logo-wrapper.indi-mini-card-company-logo-wrapper {\n  max-width: 50px;\n  float: right;\n  right: 5px;\n} */\n\n.indi-app div[dir=\"rtl\"] .indi-card-company-logo-wrapper.indi-mini-card-company-logo-wrapper {\n  float: left;\n  right: calc(100% - 55px);\n}\n\n.indi-app .indi-ext-card-item-wrapper .indi-card-company-logo-wrapper {\n  height: 70px;\n  top: 20px;\n  right: 12px;\n}\n\n.indi-app .indi-ext-card-item-wrapper div[dir=\"rtl\"] .indi-card-company-logo-wrapper {\n  right: 0;\n  left: 22px;\n}\n\n.indi-app .indi-ext-card-item-wrapper .indi-card-upload-picture {\n  min-width: 150px;\n  min-height: 150px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  margin-top: 72px;\n  margin-bottom: 10px;\n}\n\n.indi-app .indi-ext-card-item-wrapper .indi-card-item-parent.card-with-bg {\n  padding: 24px;\n}\n\n.indi-card-field-item {}\n\n.indi-app .indi-card-select-field-item {\n  padding-left: 2px;\n}\n\n.indi-app .indi-card-select-field-item option {\n  /* color: #000; */\n  background-color: #232762;\n}\n\n.indi-card-field-item-img {\n  min-width: 26px;\n  height: 24px;\n  margin-right: 8px;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\ndiv[dir=\"rtl\"] .indi-card-field-item-img {\n  margin-right: 0px;\n  margin-left: 8px;\n}\n\n/* .indi-card-field-item-img.indi-card-field-item-phone {\n  background-image: url(\"./../img/fields/phone.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-address {\n  background-image: url(\"./../img/fields/addresses.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-vimeo {\n  background-image: url(\"./../img/fields/vimeo.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-wechat {\n  background-image: url(\"./../img/fields/wechat.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-instagram {\n  background-image: url(\"./../img/fields/instagram.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-youtube {\n  background-image: url(\"./../img/fields/youtube.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-mobile {\n  background-image: url(\"./../img/fields/phone.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-linkedin {\n  background-image: url(\"./../img/fields/linkedin.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-wechat {\n  background-image: url(\"./../img/fields/wechat.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-link {\n  background-image: url(\"./../img/fields/link.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-website {\n  background-image: url(\"./../img/fields/website.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-twitter {\n  background-image: url(\"./../img/fields/twitter.png\");\n}\n\n.indi-card-field-item-img.indi-card-field-item-email {\n  background-image: url(\"./../img/fields/email.png\");\n} */\n\n.indi-card-field-item-value {\n  color: #fff;\n  word-wrap: break-word;\n  word-break: break-word;\n}\n\n.indi-card-field-item input,\n.indi-card-field-item textarea,\n.indi-card-field-item select {\n  min-width: 190px;\n}\n\n.indi-card-field-item input,\n.indi-card-field-item textarea,\n.indi-card-field-item select,\n.indi-card-field-item input:focus-visible,\n.indi-card-field-item textarea:focus-visible,\n.indi-card-field-item select:focus-visible {\n  border: 0;\n  background: transparent;\n  border-bottom: 1px solid darkgrey;\n  color: #fff;\n}\n\n.indi-email-form-page.indi-card-field-item input,\n.indi-email-form-page.indi-card-field-item textarea {\n  margin-bottom: 8px;\n}\n\n.indi-card-field-item input:read-only,\n.indi-card-field-item input:read-only:focus-visible {\n  /* font-style: italic; */\n  color: lightgray;\n  -moz-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);\n  -webkit-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);\n  -o-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);\n  -ms-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);\n  transform: scale(1) rotate(0deg) translate(0px, 0px) skew(160deg, 0deg);\n}\n\n.indi-card-field-item input:focus-visible {\n  border-bottom: 1px solid #dedada;\n  outline: none;\n}\n\n@media screen and (max-width : 1800px) {\n  .indi-app .indi-card-item-wrapper {\n    width: 239px;\n    min-width: 239px;\n  }\n}\n\n.indi-card-mini-item-wrapper {\n  width: 100%;\n}\n\n.indi-app .indi-card-mini-item-wrapper .indi-card-item-parent.card-with-bg {\n  border-radius: 10px;\n}\n\n.indi-app .indi-card-mini-item-wrapper .indi-info-wrapper {\n  border-radius: 10px;\n  width: 100%;\n  text-align: left;\n  margin-top: 40px;\n}\n\n.indi-app .indi-card-mini-items-wrapper {\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  overflow-y: overlay;\n}\n\n.indi-app .indi-card-mini-options-wrapper {\n  justify-content: center;\n  padding: 8px;\n}\n\n.indi-app .indi-card-mini-options-wrapper Button {\n  margin: 5px;\n}\n\n\n.indi-app .btn .btn-primary,\n.btn.indi-mini-card-selection-btn {\n  border-color: #234c8e;\n  /* color: #234c8e; */\n  color: #fff;\n  font-weight: 600;\n  border-width: 2px;\n}\n\n.indi-app .btn-check:checked+.btn,\n.indi-app .btn.active,\n.indi-app .btn.show,\n.indi-app .btn:first-child:active,\n.indi-app :not(.btn-check)+.btn:active,\n.indi-app .btn-check:checked+.btn.indi-mini-card-selection-btn {\n  background-color: #234c8e;\n  border-color: #234c8e;\n  color: #fff\n}\n\n.btn-group>.btn-group:not(:last-child)>.btn,\n.btn-group>.btn.dropdown-toggle-split:first-child,\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn:last-child:not(.dropdown-toggle) {\n  background-color: #ffffff;\n  color: #234c8e;\n}\n\n/* .indi-app .indi-card-item-wrapper.indi-card-mini-item-wrapper.btn .indi-mini-card-name {\n  color: #234c8e;\n} */\n\n.indi-app .btn-check+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary {\n  background-color: transparent;\n  border-radius: 10px;\n  outline: none;\n  border: 0;\n  box-shadow: none;\n  transition: all 0.3s ease 0s;\n  margin: 16px;\n  padding: 0;\n  width: 210px;\n  max-width: 280px;\n  height: 140px;\n}\n\n\n.indi-app .btn-check+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary:hover {\n  box-shadow: -2px 6px 14px rgb(0 0 0 / 80%);\n}\n\n.indi-app .btn-check:checked+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary {\n  box-shadow: -2px 6px 14px rgb(0 0 0 / 80%);\n  outline: 2px solid #fff;\n  height: 154px;\n  padding-bottom: 24px;\n  margin-top: 14px;\n}\n\n.indi-app .btn-check:checked+.btn.indi-card-item-wrapper.indi-card-mini-item-wrapper.btn-outline-primary .indi-mini-card-name {\n  font-weight: 700;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indi-app .indi-ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  width: inherit;\n  text-overflow: ellipsis;\n}\n\n.indi-float-left {\n  float: left !important;\n}\n\n.indi-float-right {\n  float: right !important;\n}\n\n.indi-app .indi-card-qr-code {\n  width: 32px;\n  height: 32px;\n  float: right;\n  margin-bottom: 4px;\n  margin-left: 6px;\n}\n\n.indi-app .indi-info-left {\n  overflow: hidden;\n}\n\n.indi-app .indi-copy-signature-wrapper,\n.indi-app .indi-signature-item-wrapper {\n  justify-content: center;\n  padding: 0 0 24px 0;\n  min-height: 230px;\n}\n\n.indi-app .indi-mini-card-list {\n  margin: 0 auto;\n  overflow-x: auto;\n  min-height: 200px;\n  justify-content: space-between;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-signature-item {\n  border-radius: 10px;\n  min-width: 400px;\n  max-width: 400px;\n  box-shadow: 0px 1px 6px #000;\n  min-height: 192px;\n  border: 2px solid transparent;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-qrcode-box.row {\n  background-color: #fff;\n  margin: 0;\n  border-radius: 10px;\n  position: relative;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-signature-item.indi-temp-border-for-email-signature {\n  border: 2px solid #ccc;\n}\n\n/* .indi-app .indi-signature-item-wrapper .indi-signature-item.indi-temp-border-for-email-signature *{\n  background-color: transparent !important;\n} */\n\n.indi-app .indi-qrcode-logo {\n  border-radius: 10px;\n}\n\n.indi-app .indi-qrcode-box-img-col img.indi-qrcode-bg {\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  bottom: 10px;\n  right: -2px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  box-shadow: 0px 0px 4px 0px #000;\n}\n\n.indi-app div[dir=\"rtl\"] .indi-qrcode-box-img-col img.indi-qrcode-bg {\n  right: unset;\n  left: -2px;\n}\n\n.indi-app .indi-qrcode-logo {\n  width: 100px;\n  height: 100px;\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n}\n\n.indi-app .indi-signature-template {\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.indi-app .indi-signature-template .indi-qrcode-box-info-col div span {\n  display: table-cell;\n  padding-bottom: 8px;\n  line-height: 18px;\n}\n\n.indi-app .indi-qrcode-box-personal-desgination,\n.indi-app .indi-qrcode-box-personal-special-text {\n  position: relative;\n  top: -12px;\n  max-width: calc(100% - 56px);\n}\n.indi-app .indi-qrcode-box-personal-special-text {\n  font-style: italic;\n  font-weight: 700;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.indi-app .indi-signature-template .indi-qrcode-box-info-col div span.indi-card-field-item-img {\n  /* background-size: 20PX;\n  background-position: 0px 2px;\n  background-repeat: no-repeat;\n  width: 32px;\n  height: 26px;\n  background-repeat: no-repeat; */\n  padding-bottom: 0;\n}\n\n.indi-app .indi-qrcode-qrcode {\n  height: 120px;\n}\n\n.indi-app .indi-ext-card-details-page {\n  background-image: url(\"./../img/sos-header-right-bg.png\");\n  background-attachment: fixed;\n  background-position: right;\n  min-height: 100vh;\n  width: 100vw;\n  background-repeat: no-repeat;\n  background-size: contain;\n  float: left;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.indi-app .indi-ext-card-details-page .indi-globe-bg {\n  background-image: url(\"./../img/globe.svg\");\n  background-position: left;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: fixed;\n  height: 100vh;\n  width: 90%;\n  left: -48%;\n  top: 0;\n  transform: scaleX(-1);\n  background-attachment: fixed;\n}\n\n.indi-ext-card-item-wrapper {\n  justify-content: center;\n  width: 442px;\n  margin: 0 auto;\n  padding: 40px 0;\n  height: auto;\n}\n\n.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  border-radius: 3px;\n  position: relative;\n}\n\n.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page {\n  margin: 0 20px;\n  width: calc(100% - 40px);\n  height: 40vh;\n}\n\n.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page .indi-ext-card-error-page-title {\n  height: 24px;\n  font-size: 24px;\n  line-height: 24px;\n}\n\n.indi-ext-card-item-wrapper.indi-ext-card-error-page-wrapper .indi-ext-card-error-page .indi-ext-card-error-page-message {\n  margin: 0 auto;\n  display: flex;\n  /* padding: 50px; */\n  width: 100%;\n  position: relative;\n  justify-content: center;\n  height: calc(100% - 24px);\n  text-align: center;\n  vertical-align: middle;\n  /* height: 100%; */\n  padding: 100px 0;\n  /* color: red; */\n}\n\n.indi-app .indi-card-with-actions {\n  cursor: pointer;\n}\n\n.indi-app .indi-card-with-actions.indi-card-item-parent.card-with-bg:hover {\n  box-shadow: 0px 8px 15px rgb(0 0 0 / 60%) !important;\n  background-color: transparent;\n  outline: none;\n  border: 0;\n  box-shadow: none;\n  transition: all 0.3s ease 0s;\n}\n\n.indi-app .indi-card-details-wrapper>div {\n  margin-right: 42px;\n}\n\n.indi-app .indi-card-item-page2-qrcode-image img {\n  height: 100px;\n}\n\n.indi-app .indi-card-item-page2 {\n  justify-content: space-between;\n}\n\n.indi-app .indi-modal-dialog-alert .modal-body {\n  padding: 0 !important;\n}\n\n.indi-app .indi-modal-dialog-alert-body {\n  margin: 0 !important;\n}\n\n.indi-app .indi-email-form-page form {\n  display: flex;\n  flex-direction: column;\n}\n\n.indi-app .indi-card-upload-picture-file-input {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  opacity: 0;\n  position: absolute;\n  height: 100px;\n  border: 1px solid red;\n  width: 100px;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.indi-app .indi-card-upload-picture.indi-card-upload-picture-with-no-bg:hover {\n  background-image: url(\"../img/Upload.png\");\n  background-color: rgb(255, 255, 255, 0.5);\n  background-repeat: no-repeat;\n  background-size: contain;\n  /* transform: rotate(180deg); */\n}\n\n.indi-app .indi-card-upload-picture-card-image {\n  height: 100px;\n  width: 100px;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.indi-app .indi-card-upload-picture-with-no-bg:hover {\n  cursor: pointer;\n}\n\n.indi-app .indi-card-upload-picture-with-no-bg:hover .indi-card-upload-picture-card-image {\n  opacity: 0.3;\n}\n\n.indi-app .indi-card-upload-picture.indi-card-upload-picture-with-no-bg:hover {\n  background-color: rgb(255, 255, 255, 1);\n}\n\n.indi-app .indi-card-upload-picture-img {\n  height: 100px;\n  width: 100px;\n  border-radius: 50%;\n}\n\n.indi-app .indi-ext-card-item-wrapper .indi-card-upload-picture-img {\n  height: 150px;\n  width: 150px;\n}\n\n.indi-app .indi-table-img-cell {\n  width: 24px;\n  height: 24px;\n}\n\n.indi-app .cropper-crop-box,\n.cropper-view-box {\n  border-radius: 50%;\n}\n\n.indi-app .cropper-view-box {\n  box-shadow: 0 0 0 1px #39f;\n  outline: 0;\n}\n\n.indi-app .cropper-face {\n  background-color: inherit !important;\n}\n\n.indi-app .cropper-dashed,\n.cropper-line {\n  display: none !important;\n}\n\n.indi-app .cropper-view-box {\n  outline: inherit !important;\n}\n\n.indi-app .cropper-point.point-se {\n  top: calc(85% + 1px);\n  right: 14%;\n}\n\n.indi-app .cropper-point.point-sw {\n  top: calc(85% + 1px);\n  left: 14%;\n}\n\n.indi-app .cropper-point.point-nw {\n  top: calc(15% - 5px);\n  left: 14%;\n}\n\n.indi-app .cropper-point.point-ne {\n  top: calc(15% - 5px);\n  right: 14%;\n}\n\n.indi-app .indi-crop-dialog-modal-img-wrapper {\n  background-color: #2f4696;\n  padding: 20px;\n  height: 240px;\n  border-radius: 5px;\n}\n\n.indi-app .indi-crop-card-info-btn {\n  height: 28px;\n  width: 28px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  font-style: italic;\n  color: #fff;\n  text-align: center;\n  margin: 10px;\n  font-weight: 700;\n}\n\n.indi-app .popover .popover-arrow {\n  display: none !important;\n}\n\n.indi-app .indi-modal-card-crop-btn-wrapper {\n  padding: 10px 0;\n}\n\n.indi-app .indi-modal-card-crop-btn-wrapper Button {\n  margin-right: 5px;\n  background-color: #232862;\n}\n\n.indi-app .cropper-modal {\n  opacity: 1;\n  background-color: transparent;\n}\n\n.indi-app .indi-add-card-page-badge-ribbon-wrapper,\n.indi-app .indi-edit-card-page-badge-ribbon-wrapper {\n  width: calc(100% - 150px);\n  justify-content: flex-start;\n  align-items: flex-start;\n  text-align: center;\n  padding: 16px;\n  display: flex;\n  overflow-x: auto;\n  overflow-x: overlay;\n}\n\n.indi-app .indi-edit-card-page-badge-ribbon-wrapper {\n  width: calc(100% - 170px);\n}\n\n.indi-app .indi-add-card-page-footer-btn-wrapper {\n  width: 150px;\n  margin: auto 0;\n}\n\n.indi-app .indi-badges-ribbon-wrapper {\n  justify-content: center;\n}\n\n.indi-app .indi-badge-item-wrapper {\n  margin-right: 12px;\n  font-size: 12px;\n}\n\n.indi-app .indi-badge-item-icon-image {\n  width: 24px;\n  height: 24px;\n}\n\n.indi-app .indi-badge-freeze {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.indi-app .indi-badge-field-remove {\n  font-size: 10px;\n  border: 1px solid grey;\n  border-radius: 50%;\n  height: 18px;\n  width: 18px;\n  text-align: center;\n  color: #abb5d7;\n}\n\n.indi-app .indi-badge-field-remove:hover {\n  border: 1px solid #fff;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n\n.indi-app .indi-data-table-header {\n  background-color: #304697 !important;\n  color: #fff !important;\n}\n\n.indi-app .indi-data-table-wrapper {\n  padding: 16px;\n  overflow: auto;\n  overflow: overlay;\n  height: calc(100% - 32px);\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper.indi-text-btn-row {\n  justify-content: space-between;\n  align-items: center;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .form-floating {\n  flex: 1 1 0;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td {\n  vertical-align: middle;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td input[type=checkbox] {\n  border-color: #2f4696;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .indi-data-table-tr td input[type=text] {\n  height: calc(2rem + 2px);\n  line-height: 1.25;\n  border-color: #2f4696;\n  min-width: 200px;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-body {\n  overflow: auto;\n  padding: 0;\n  margin: 16px;\n  font-weight: bold;\n  color: #304697;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-item .accordion-button {\n  color: #2f4594;\n  font-weight: bold;\n}\n\n.indi-app .indi-add-template-form .indi-data-table-wrapper .accordion-item .accordion-button:not(.collapsed) {\n  background-color: #2b5daf40;\n  font-weight: bold;\n  color: #232862;\n}\n\n.indi-app .indi-add-template-form .indi-add-card-title {\n  height: 46px;\n}\n\n.indi-app .indi-add-page-footer-btn-wrapper.float-right {\n  float: right;\n}\n\n.indi-app tr.indi-data-table-tr {\n  background-color: #f5f8fc;\n  border-top: 5px solid #f0f3f9;\n  color: #304697;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.indi-app .indi-data-table-checkbox-all {\n  opacity: 0;\n}\n\n.indi-app .indi-table-header-searchbox {\n  width: 50px;\n}\n\n.indi-app .indi-tamplte-empty-field-value {\n  font-size: 14px;\n  color: darkgrey;\n  font-style: italic;\n}\n\n.indi-app .indi-email-signature-footer {\n  justify-content: right;\n  display: flex;\n  margin: 0 10px 10px 0;\n}\n\n.indi-app .indi-email-signature-footer Button {\n  background-color: #2f4696;\n  border-color: #2f4696;\n\n}\n\n/* indi-add-form-item-input */\n.indi-app .indi-img-preview {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-size: contain !important;\n  background-repeat: no-repeat;\n}\n\n.indi-app .indi-img-preview.indi-dark-img-preview {\n  border-radius: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.indi-app .indi-add-form-wrapper {\n  justify-content: start;\n  min-height: 300px;\n  height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.indi-app .indi-upload-picture-file-input {\n  opacity: 0;\n  position: absolute;\n}\n\n.indi-app .indi-data-table-td-template-image .indi-upload-picture-file-input {\n  left: 0;\n}\n\n\n.indi-app .indi-add-img-wrapper {\n  background-image: url(\"../img/Upload1.png\");\n  background-color: rgb(255, 255, 255, 0.5);\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.indi-app .indi-upload-picture-file-input,\n.indi-app .indi-add-img-wrapper {\n  width: 72px;\n  height: 58px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  margin: 0 20px;\n  cursor: pointer;\n}\n\n.indi-app .indi-data-table-tr .indi-upload-picture-file-input,\n.indi-app .indi-data-table-tr .indi-add-img-wrapper {\n  margin: 0;\n}\n\n.indi-app .form-floating>.form-control-plaintext~label,\n.indi-app .form-floating>.form-control:focus~label,\n.indi-app .form-floating>.form-control:not(:placeholder-shown)~label,\n.indi-app .form-floating>.form-select~label {\n  opacity: 1;\n  background: #fff;\n  width: auto;\n  -webkit-transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);\n  transform: scale(.85) translateY(-0.8rem) translateX(0.5rem);\n  height: auto;\n  color: #2f4696;\n  padding: 0 4px;\n  margin: 0 8px;\n}\n\n.indi-app .form-floating>.form-control,\n.indi-app .form-floating>.form-control-plaintext,\n.indi-app .form-floating>.form-select {\n  height: calc(2rem + 2px);\n  line-height: 1.25;\n  border-color: #2f4696;\n  padding: 1rem;\n}\n\n.indi-app .form-floating>.form-select.indi-multi-input-select-field {\n  height: 100px;\n}\n\n.indi-app .form-floating>textarea.form-control {\n  height: auto;\n}\n\n.indi-app .form-floating>.form-select {\n  height: 28px;\n  margin-top: 8px;\n  padding-right: 40px;\n}\n\n.indi-app .indi-empty-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80%;\n  font-size: 18px;\n  border: 1px solid;\n  margin: 16px;\n}\n\n.indi-app .form-floating>.form-control.indi-input-textarea-field {\n  height: 90px;\n}\n\n\n.indi-app .form-floating>.form-control-plaintext:focus,\n.indi-app .form-floating>.form-control-plaintext:not(:placeholder-shown),\n.indi-app .form-floating>.form-control:focus,\n.indi-app .form-floating>.form-control:not(:placeholder-shown),\n.indi-app .form-floating>.form-select {\n  /* padding-top: 0; */\n  padding-top: 3px;\n  padding-bottom: 0;\n  border-color: #2f4696;\n}\n\n.indi-app .form-floating>textarea.form-control:not(:placeholder-shown) {\n  padding-top: 10px;\n}\n\n.indi-app .form-floating>label {\n  padding: 0.25rem 1rem;\n  color: #2f4696;\n}\n\n.indi-app .form-control:focus,\n.indi-app .form-select:focus {\n  box-shadow: 0 0 0 2px rgb(13 110 253 / 20%);\n}\n\n.indi-app .indi-add-form-item {\n  margin: 12px 0;\n}\n\n.indi-app .indi-add-form-item-label {\n  color: #2f4696;\n  font-weight: bold;\n  flex: 1 0 0;\n}\n\n\n.indi-app .indi-add-template-badge-icon-image {\n  width: 24px;\n  height: 24px;\n}\n\n.indi-app .indi-add-img-wrapper-preview {\n  width: 32px;\n}\n\n.indi-app .indi-data-table-td-template-image {\n  display: flex;\n  justify-content: center;\n}\n\n.indi-app .indi-data-table-td-template-img-prevew {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.indi-app .indi-upload-picture-file-input-wrapper {\n  position: relative;\n}\n\n.indi-app .indi-template-field-item-img {\n  min-width: 26px;\n  height: 24px;\n  margin-right: 8px;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n}\n\n.indi-app .indi-add-card-template-preview {\n  background-image: url(\"../img/eye.png\");\n  width: 32px;\n  height: 32px;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.indi-app .indi-add-card-template-preview-wrapper {\n  justify-content: center;\n}\n\n.indi-app .indi-add-card-template-cell {\n  vertical-align: middle;\n}\n\n.indi-app .indi-card-template-preview-wrapper {\n  max-height: 500px;\n  overflow: auto;\n  overflow: overlay;\n}\n\n\n.indi-app .indi-user-settings-page-wrapper {\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  overflow-y: overlay;\n}\n\n.indi-app .indi-user-settings-page-card {\n  width: 220px;\n  min-width: 220px;\n  margin: 16px;\n  /* border-radius: 10px; */\n  padding: 0;\n  background: #fff;\n  /* box-shadow: 0px 1px 6px #000; */\n  min-height: 192px;\n}\n\n.indi-app .indi-user-settings-page-card-inner {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  width: 100%;\n  /* height: 100%; */\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner {\n  flex-direction: row;\n  background-color: #5e6aae69;\n  padding: 5px 10px;\n}\n\n.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-profile-wrapper {\n  max-height: 150px;\n  overflow: auto;\n  overflow: overlay;\n}\n\n.indi-app .indi-user-settings-page-profile .indi-user-profile-delete-btn {\n  top: 0;\n}\n\n.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner.indi-user-settings-page-card-inner-profile {\n  margin: 2px 0;\n}\n\n.indi-app .indi-user-settings-add-profile-btn {\n  font-weight: bold;\n  color: #2f4694;\n  line-height: 18px;\n  padding-left: 5px;\n  font-size: 16px;\n  top: 10px;\n}\n\n\n.indi-app .indi-user-settings-add-profile-btn:hover {\n  cursor: pointer;\n}\n\n.indi-app .indi-user-settings-page-card-header {\n  padding: 12px 8px 20px 8px;\n  position: relative;\n}\n\n.indi-app .indi-user-settings-page-card-header-img {\n  width: 16px;\n  height: 16px;\n}\n\n.indi-app .indi-user-settings-page-image {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n}\n\n.indi-app .indi-user-settings-page-change-email {\n  flex-direction: column;\n  cursor: default;\n}\n\n.indi-app .indi-user-settings-page-card-header-label {\n  font-weight: bold;\n  color: #2f4694;\n  line-height: 18px;\n  padding-left: 5px;\n  font-size: 12px;\n}\n\n.indi-app .indi-user-settings-page-card-inner-item {\n  /* background-color: #f0f3f9; */\n  width: 100%;\n  padding: 5px 10px;\n}\n\n.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password {\n  /* background-color: transparent; */\n  line-height: 34px;\n}\n\n.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password,\n.indi-app .indi-user-settings-page-card-inner-item {\n  background-color: transparent;\n}\n\n.indi-app .indi-user-settings-page-profile .indi-user-settings-page-card-inner:hover,\n.indi-app .indi-user-settings-page-card-inner-item.indi-user-settings-page-reset-password:hover,\n.indi-app .indi-user-settings-page-card-inner-item:hover {\n  background-color: #23286236;\n}\n\n.indi-app .indi-user-settings-page-change-email-label {\n  font-weight: 500;\n}\n\n.indi-app .indi-user-settings-page-change-email-value {\n  font-size: 12px;\n  word-break: break-all;\n}\n\n.indi-app .indi-user-settings-page-display-name {\n  margin-left: 7px;\n}\n\n.indi-modal-edit-user-profile-resetpassword-section:not(.indi-modal-edit-user-profile-resetpassword),\n.indi-modal-edit-user-profile-profile-section:not(.indi-modal-edit-user-profile-profile),\n.indi-modal-edit-user-profile-email-section:not(.indi-modal-edit-user-profile-email) {\n  display: none;\n}\n\n.indi-app .indi-modal-edit-user-profile-floating-inputs {\n  margin-bottom: 20px;\n}\n\n.indi-app .indi-modal-edit-user-profile-header-title {\n  color: #2f4694;\n}\n\n.indi-app .indi-user-profile-settings-error-msg {\n  left: 12px;\n  position: absolute;\n  bottom: 20px;\n  max-width: 270px;\n  color: red;\n}\n\n.indi-app .indi-card-upload-picture-file-input-wrapper {\n  min-width: 100px;\n  min-height: 100px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  max-width: 100px;\n  max-height: 100px;\n  overflow: hidden;\n}\n\n.indi-app .indi-card-upload-picture-file-input-wrapper:hover {\n  background-image: url(\"../img/Upload.png\");\n  background-color: rgb(255, 255, 255, 0.5);\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.indi-app .indi-card-upload-picture-img-input {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  opacity: 1;\n  position: absolute;\n  height: 100px;\n  border: 1px solid #232862;\n  width: 100px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.indi-app .indi-card-upload-picture-file-input-wrapper:hover .indi-card-upload-picture-img-input {\n  opacity: 0.5;\n}\n\n.indi-app .modal-header .modal-title.h4 {\n  color: #2f4694;\n  font-size: 18px;\n}\n\n.indi-app .indi-modal-addr-preview-contact-number-wrapper {\n  display: flex;\n  justify-content: end;\n}\n\n.indi-app .indi-modal-addr-preview-full-address {\n  width: 100%;\n  height: 70px;\n  border: 1px solid grey;\n  border-radius: 3px;\n  background-color: #d3d3d340;\n  margin-top: 18px;\n  padding: 5px 10px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.indi-app .indi-modal-addr-preview-contact-number {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 28px;\n  margin-left: 10px;\n}\n\n.indi-app .indi-select-address-modal-body {\n  padding-bottom: 0;\n}\n\n.indi-app .indi-select-address-modal-footer {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.indi-app .indi-add-card-select-address-field {\n  font-style: italic;\n  background-color: #d3d3d340;\n}\n\n.indi-app .indi-add-card-address-telephone-wrapper {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.indi-app .indi-add-card-address-telephone {\n  width: 16px;\n  height: 16px;\n  background-image: url(\"./../img//fields/telephone.png\");\n  display: inline-flex;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.indi-app .indi-add-card-address-telephone-value {\n  font-size: 12px;\n  font-style: italic;\n  color: #ccc;\n}\n\n\n.indi-app .indi-card-address-text {\n  line-height: 18px;\n  /* font-style: italic; */\n  font-size: 14px;\n}\n\n.indi-app .indi-card-number-text {\n  margin-top: 5px;\n  font-size: 12px;\n  display: flex;\n}\n\n.indi-app .indi-email-sign-generate-item {\n  /* border-left: 1px solid blue; */\n  padding-bottom: 14px;\n}\n\n.indi-app .indi-email-sign-generate-item,\n.indi-app .indi-email-sign-generate-body {\n  padding-left: 28px;\n  position: relative;\n}\n\n\n.indi-app .indi-email-sign-vertical-line::before {\n  background-color: #304697;\n  bottom: 0px;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  top: 0px;\n  transform: translateX(-50%);\n  width: 2px;\n}\n\n.indi-app .indi-email-sign-generate-item:first-child .indi-email-sign-vertical-line::before {\n  top: 10px;\n}\n\n.indi-app .indi-email-sign-generate-item:last-child .indi-email-sign-vertical-line::before {\n  height: 18px;\n  bottom: auto;\n}\n\n.indi-app .indi-email-sign-vertical-line::after {\n  background-color: #304697;\n  border-radius: 50%;\n  content: \"\";\n  height: 14px;\n  left: 0;\n  position: absolute;\n  top: calc(0.75rem);\n  transform: translateX(-50%) translateY(-50%);\n  width: 14px;\n}\n\n\n\n.indi-app .indi-email-sign-help-heading {\n  font-size: 12px;\n  font-weight: 700;\n\n}\n\n.indi-app .indi-email-sign-help-link {\n  font-size: 16px;\n}\n\n.indi-app .indi-email-sign-help-link>a {\n  text-decoration: none;\n  line-height: 14px;\n  display: block;\n  color: #304697;\n}\n\n.indi-app .indi-email-sign-tab-content-right-side-area {\n  max-width: 400px;\n}\n\n.indi-app .indi-email-sign-tab-panel-heading {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.indi-app .indi-email-sign-tab-panel-sub-heading {\n  font-size: 10px;\n}\n\n.indi-app .nav-pills .nav-link {\n  background-color: transparent;\n  color: #304697;\n}\n\n.indi-app .nav-pills .nav-link.active {\n  background-color: #304697;\n  color: #fff;\n}\n\n.indi-app .indi-temp-dummy {\n  position: fixed;\n  top: 0;\n  left: 0;\n  image-rendering: pixelated;\n}\n\n.indi-app .indi-email-sign-copy-clipboard-img-wrapper {\n  max-width: 400px;\n  max-height: 225px;\n  position: relative;\n  display: block;\n  image-rendering: pixelated;\n}\n\n.indi-app .indi-email-sign-copy-clipboard-img-wrapper img {\n  image-rendering: pixelated;\n}\n\n.indi-app .indi-temp-dummy-img {\n  height: 100px;\n  width: 200px;\n}\n\n.indi-app .indi-email-sign-copied-to-clipboard-alert {\n  position: fixed;\n  top: 5px;\n  z-index: 1;\n}\n\n.indi-app .indi-temp-dummy-img img {\n  height: 150px;\n  width: 275px;\n  border-radius: 10px;\n  box-shadow: 0px 1px 6px #000;\n}\n\n.indi-app .indi-add-card-name-input,\n.indi-app .indi-add-card-custom-id-input,\n.indi-app .indi-add-card-profile-input {\n  min-width: 250px;\n}\n\n.indi-app .indi-card-form-error .indi-add-card-custom-id-input {\n  color: red;\n  border-bottom-color: red;\n}\n\n.indi-app .indi-bulk-upload-img {\n  width: 24px;\n  height: 24px;\n  margin: 0 8px;\n}\n\n.indi-app .indi-bulk-upload-file-name.indi-img-preview {\n  width: 100%;\n}\n\n/* .indi-app .indi-card-ext-footer-btn {\n  position: absolute;\n  bottom: 4px;\n  width: 400px;\n  justify-content: flex-end;\n  display: flex;\n} */\n\n.indi-app .indi-card-ext-footer-btn img {\n  width: 32px;\n  height: 32px;\n  margin: 0 0 10px 10px;\n}\n\n/* \n.indi-app .indi-card-ext-footer-btn img:last-child {\n  margin-left: 10px;\n}\n */\n.indi-app .indi-mini-card-list .indi-mini-card-badge-icons-wrapper {\n  overflow-x: auto;\n  white-space: nowrap;\n  max-width: 200px;\n}\n.indi-app .indi-mini-card-list .indi-mini-card-badge-icon {\n  width: 14px;\n  margin: 3px;\n}\n\n.indi-app .indi-signature-item-wrapper .indi-mini-card-badge-icon {\n  width: 20px;\n  height: 20px;\n  margin: 4px;\n}\n\n.indi-app .indi-ext-card-social-link {\n  color: #fff;\n}\n\n.indi-app .indi-apply-dark-background {\n  /* background-color: rgba(0, 0, 0, 0.5); */\n  background-color: rgba(48, 82, 158, .5);\n}\n\n.indi-app .indi-disable-action-icon {\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.indi-app .indi-card-external-badge-wrapper {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: end;\n}\n\n.indi-app .indi-card-external-badge-wrapper img {\n  display: flex;\n  flex-direction: row;\n  height: 16px;\n  width: 16px;\n  margin-left: 6px;\n}\n\n.indi-app .indi-send-email-form-disable {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: default;\n}\n\n.indi-tick-mark {\n  position: relative;\n  /* display: inline-block; */\n  width: 14px;\n  height: 14px;\n  margin: 0 auto;\n}\n\n.indi-tick-mark::before,\n.indi-tick-mark::after {\n  position: absolute;\n  left: 0;\n  /* #409933 */\n  background-color: #9acd32;\n  content: \"\";\n  transform: translateX(10px) rotate(-45deg);\n  transform-origin: left bottom;\n  /* opacity: 0.5; */\n}\n\n.indi-tick-mark::before {\n  top: 50%;\n  height: 50%;\n  width: 3px;\n}\n\n.indi-tick-mark::after {\n  bottom: 0;\n  height: 3px;\n  width: 100%;\n}\n\n.indi-tick-mark.indi-double-tick-mark::before,\n.indi-tick-mark.indi-double-tick-mark::after {\n  opacity: 1;\n  background-color: #336699;\n}\n\n.indi-app .indi-range-input {\n  padding-top: 29px;\n}\n\n.tooltip {\n  pointer-events: none !important;\n}\n\n\n.indi-app .fade.show.bs-tooltip-bottom {\n  transform: translate(0px, 0px);\n  inset: 0px auto auto 0px;\n  position: absolute;\n}\n\n.indi-app .bs-tooltip-bottom .tooltip-arrow::before {\n  border-bottom-color: #304697;\n}\n\n.indi-app .tooltip-inner {\n  background-color: #304697;\n}\n\n.indi-app .indi-up-arrow,\n.indi-app .indi-down-arrow {\n  /* background: url(\"../img/arrow.png\") no-repeat; */\n  height: 10px;\n  width: 20px;\n  background-size: contain;\n  cursor: pointer;\n  opacity: 0;\n  margin-left: 2px;\n}\n\n.indi-app .indi-card-field-item:hover .indi-up-arrow,\n.indi-app .indi-card-field-item:hover .indi-down-arrow {\n  opacity: 1;\n}\n\n.indi-app .indi-down-arrow {\n  /* -webkit-transform: scaleY(-1);\n  transform: scaleY(-1); */\n}\n\n.indi-app .indi-arrow {\n  border: solid #fff;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n\n.indi-app .indi-right {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.indi-app .indi-left {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.indi-app .indi-up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n\n.indi-app .indi-down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n\n.indi-app .indi-reset-user-password-list-item {\n  margin-left: 10px;\n}\n\n.indi-app .indi-users-table-region-dropdown {\n  min-width: 75px;\n  width: auto;\n  max-width: 135px;\n}\n\n.indi-app .indi-email-signature-empty-page {\n  margin: 0 auto;\n  justify-content: center;\n  text-align: center;\n  font-size: 24px;\n  display: flex;\n  position: relative;\n  top: calc(50% - 18px);\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image-wrapper {\n  /* background-color: rgba(255, 255, 255, 0.5); */\n  max-height: 72px;\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image {\n  margin-left: 5px;\n  font-size: 12px;\n  color: #ccc;\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image:hover {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #fff;\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-small {\n  width: 16px;\n  width: 16px;\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-medium {\n  width: 32px;\n  width: 32px;\n}\n\n.indi-app .indi-card-item-page2-qrcode-download-image.indi-card-item-page2-qrcode-download-image-large {\n  width: 64px;\n  width: 64px;\n}\n\n.indi-app .btn.show.indi-header-userprofile-btn {\n  background-color: transparent;\n}\n.indi-app .indi-analytics-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 40px;\n}\n.indi-app .indi-input-field.indi-color-input-field {\n  border: none;\n  background-color: transparent;\n  width: 38px;\n  margin-left: 5px;\n}\n\n.indi-joint-image {\n  position: relative;\n  width: 50%;\n  max-width: 50%;\n}\n\n.indi-joint-image img {\n  position: relative;\n  height: 40px;\n}\n\n.indi-joint-left-image img {\n  float: left;\n  left: 0;\n}\n\n.indi-app div[dir=\"rtl\"] .indi-joint-left-image img {\n  float: right;\n  right: 0;\n}\n\n.indi-joint-right-image img {\n  float: right;\n  right: 0;\n}\n\n.indi-app div[dir=\"rtl\"] .indi-joint-right-image img {\n  float: left;\n  left: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
